//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.3.0.0 (NJsonSchema v11.2.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import ClientBase from './clientBase';

export class Client extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Searches addresses
     * @param q (optional) 
     * @param autocomplete (optional) 
     * @param fuzzy (optional) 
     * @return OK
     */
    searchAddresses(q: string | undefined, autocomplete: boolean | undefined, fuzzy: boolean | undefined, signal?: AbortSignal): Promise<any> {
        let url_ = this.baseUrl + "/Address/adgangsadresser?";
        if (q === null)
            throw new Error("The parameter 'q' cannot be null.");
        else if (q !== undefined)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (autocomplete === null)
            throw new Error("The parameter 'autocomplete' cannot be null.");
        else if (autocomplete !== undefined)
            url_ += "autocomplete=" + encodeURIComponent("" + autocomplete) + "&";
        if (fuzzy === null)
            throw new Error("The parameter 'fuzzy' cannot be null.");
        else if (fuzzy !== undefined)
            url_ += "fuzzy=" + encodeURIComponent("" + fuzzy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchAddresses(_response);
        });
    }

    protected processSearchAddresses(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Finds the address nearest to a coordinate
     * @param x (optional) 
     * @param y (optional) 
     * @return OK
     */
    getNearestAddress(x: number | undefined, y: number | undefined, signal?: AbortSignal): Promise<any> {
        let url_ = this.baseUrl + "/Address/adgangsadresser/reverse?";
        if (x === null)
            throw new Error("The parameter 'x' cannot be null.");
        else if (x !== undefined)
            url_ += "x=" + encodeURIComponent("" + x) + "&";
        if (y === null)
            throw new Error("The parameter 'y' cannot be null.");
        else if (y !== undefined)
            url_ += "y=" + encodeURIComponent("" + y) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNearestAddress(_response);
        });
    }

    protected processGetNearestAddress(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("No Content", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Adds the nearest address to every row of a CSV of coordinates
     * @param file (optional) 
     * @return OK
     */
    addNearestAddressesToCsv(file: FileParameter | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Address/nearest-address-csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddNearestAddressesToCsv(_response);
        });
    }

    protected processAddNearestAddressesToCsv(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    reusableComponentsAll(signal?: AbortSignal): Promise<ReuseableComponentAttributeDTO[]> {
        let url_ = this.baseUrl + "/Admin/ReusableComponents";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReusableComponentsAll(_response);
        });
    }

    protected processReusableComponentsAll(response: Response): Promise<ReuseableComponentAttributeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReuseableComponentAttributeDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReuseableComponentAttributeDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    reusableComponentsPOST(body: CreateReusableComponentDTO | undefined, signal?: AbortSignal): Promise<ReuseableComponentAttributeDTO> {
        let url_ = this.baseUrl + "/Admin/ReusableComponents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReusableComponentsPOST(_response);
        });
    }

    protected processReusableComponentsPOST(response: Response): Promise<ReuseableComponentAttributeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReuseableComponentAttributeDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReuseableComponentAttributeDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    reusableComponentsPUT(id: number, body: UpdateReuseableComponentAttributeDTO | undefined, signal?: AbortSignal): Promise<ReuseableComponentAttributeDTO> {
        let url_ = this.baseUrl + "/Admin/ReusableComponents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReusableComponentsPUT(_response);
        });
    }

    protected processReusableComponentsPUT(response: Response): Promise<ReuseableComponentAttributeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReuseableComponentAttributeDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReuseableComponentAttributeDTO>(null as any);
    }

    /**
     * @return OK
     */
    getAllQuestions(signal?: AbortSignal): Promise<QuestionDTO[]> {
        let url_ = this.baseUrl + "/Admin/Questions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllQuestions(_response);
        });
    }

    protected processGetAllQuestions(response: Response): Promise<QuestionDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createQuestion(body: CreateQuestionDTO | undefined, signal?: AbortSignal): Promise<QuestionDTO> {
        let url_ = this.baseUrl + "/Admin/Questions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateQuestion(_response);
        });
    }

    protected processCreateQuestion(response: Response): Promise<QuestionDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionDTO>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateQuestion(id: number | undefined, body: UpdateQuestionDTO | undefined, signal?: AbortSignal): Promise<QuestionDTO> {
        let url_ = this.baseUrl + "/Admin/questions?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateQuestion(_response);
        });
    }

    protected processUpdateQuestion(response: Response): Promise<QuestionDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionDTO>(null as any);
    }

    /**
     * @return OK
     */
    getChecklistsForTaskType(taskTypeId: number, signal?: AbortSignal): Promise<TaskTypeCheckListTextDTO[]> {
        let url_ = this.baseUrl + "/Admin/questions/tasktype/{taskTypeId}/GetChecklistsForTaskType";
        if (taskTypeId === undefined || taskTypeId === null)
            throw new Error("The parameter 'taskTypeId' must be defined.");
        url_ = url_.replace("{taskTypeId}", encodeURIComponent("" + taskTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetChecklistsForTaskType(_response);
        });
    }

    protected processGetChecklistsForTaskType(response: Response): Promise<TaskTypeCheckListTextDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskTypeCheckListTextDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskTypeCheckListTextDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setChecklistsForTaskType(taskTypeId: number, body: TaskTypeCheckListDTO[] | undefined, signal?: AbortSignal): Promise<TaskTypeCheckListTextDTO[]> {
        let url_ = this.baseUrl + "/Admin/questions/tasktype/{taskTypeId}/SetChecklistsForTaskType";
        if (taskTypeId === undefined || taskTypeId === null)
            throw new Error("The parameter 'taskTypeId' must be defined.");
        url_ = url_.replace("{taskTypeId}", encodeURIComponent("" + taskTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetChecklistsForTaskType(_response);
        });
    }

    protected processSetChecklistsForTaskType(response: Response): Promise<TaskTypeCheckListTextDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskTypeCheckListTextDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskTypeCheckListTextDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createReasonCode(body: CreateOrUpdateReasonCodeDTO | undefined, signal?: AbortSignal): Promise<ReasonCodeDTO> {
        let url_ = this.baseUrl + "/Admin/ReasonCodes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateReasonCode(_response);
        });
    }

    protected processCreateReasonCode(response: Response): Promise<ReasonCodeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReasonCodeDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReasonCodeDTO>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateReasonCode(id: number | undefined, body: CreateOrUpdateReasonCodeDTO | undefined, signal?: AbortSignal): Promise<ReasonCodeDTO> {
        let url_ = this.baseUrl + "/Admin/ReasonCodes?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateReasonCode(_response);
        });
    }

    protected processUpdateReasonCode(response: Response): Promise<ReasonCodeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReasonCodeDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReasonCodeDTO>(null as any);
    }

    /**
     * @param ids (optional) 
     * @return OK
     */
    deleteReasonCodes(ids: number[] | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Admin/DeleteReasonCodes?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteReasonCodes(_response);
        });
    }

    protected processDeleteReasonCodes(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Integration events received from D365 (TaskService Inbox table)
     * @param searchText (optional) 
     * @param take (optional) 
     * @return OK
     */
    getInboxMessages(searchText: string | undefined, take: number | undefined, signal?: AbortSignal): Promise<IntegrationMessageDTO[]> {
        let url_ = this.baseUrl + "/Admin/InboxMessages?";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInboxMessages(_response);
        });
    }

    protected processGetInboxMessages(response: Response): Promise<IntegrationMessageDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IntegrationMessageDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IntegrationMessageDTO[]>(null as any);
    }

    /**
     * Integration commands sent to D365 (TaskService Outbox table)
     * @param searchText (optional) 
     * @param take (optional) 
     * @return OK
     */
    getOutboxMessages(searchText: string | undefined, take: number | undefined, signal?: AbortSignal): Promise<IntegrationMessageDTO[]> {
        let url_ = this.baseUrl + "/Admin/OutboxMessages?";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOutboxMessages(_response);
        });
    }

    protected processGetOutboxMessages(response: Response): Promise<IntegrationMessageDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IntegrationMessageDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IntegrationMessageDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    adminUpdateTaskStatus(body: AdminUpdateTaskStatusCommand | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Admin/AdminUpdateTaskStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdminUpdateTaskStatus(_response);
        });
    }

    protected processAdminUpdateTaskStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param assetIdentifier (optional) 
     * @param type (optional) 
     * @return OK
     */
    asset(assetIdentifier: string | undefined, type: AssetType2 | undefined, signal?: AbortSignal): Promise<AssetResultDTO[]> {
        let url_ = this.baseUrl + "/Asset?";
        if (assetIdentifier === null)
            throw new Error("The parameter 'assetIdentifier' cannot be null.");
        else if (assetIdentifier !== undefined)
            url_ += "assetIdentifier=" + encodeURIComponent("" + assetIdentifier) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAsset(_response);
        });
    }

    protected processAsset(response: Response): Promise<AssetResultDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssetResultDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetResultDTO[]>(null as any);
    }

    /**
     * @param assetIdentifier (optional) 
     * @param type (optional) 
     * @return OK
     */
    assetDetails(assetIdentifier: string | undefined, type: AssetType2 | undefined, signal?: AbortSignal): Promise<AssetResultDTO[]> {
        let url_ = this.baseUrl + "/Asset/assetDetails?";
        if (assetIdentifier === null)
            throw new Error("The parameter 'assetIdentifier' cannot be null.");
        else if (assetIdentifier !== undefined)
            url_ += "assetIdentifier=" + encodeURIComponent("" + assetIdentifier) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssetDetails(_response);
        });
    }

    protected processAssetDetails(response: Response): Promise<AssetResultDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssetResultDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetResultDTO[]>(null as any);
    }

    /**
     * Gets all components for a Netstation SOUTH
     * @return OK
     */
    netstationComponents(stationId: string, signal?: AbortSignal): Promise<NetstationComponentsResponseDTO> {
        let url_ = this.baseUrl + "/Asset/NetstationComponents/{stationId}";
        if (stationId === undefined || stationId === null)
            throw new Error("The parameter 'stationId' must be defined.");
        url_ = url_.replace("{stationId}", encodeURIComponent("" + stationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNetstationComponents(_response);
        });
    }

    protected processNetstationComponents(response: Response): Promise<NetstationComponentsResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NetstationComponentsResponseDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NetstationComponentsResponseDTO>(null as any);
    }

    /**
     * Get component details for specific Netstation SOUTH
     * @param objectId (optional) 
     * @param componentType (optional) 
     * @return OK
     */
    netstationComponentDetails(objectId: number | undefined, componentType: StationComponentEnum | undefined, signal?: AbortSignal): Promise<ComponentDetailResponseDTO> {
        let url_ = this.baseUrl + "/Asset/NetstationComponentDetails?";
        if (objectId === null)
            throw new Error("The parameter 'objectId' cannot be null.");
        else if (objectId !== undefined)
            url_ += "objectId=" + encodeURIComponent("" + objectId) + "&";
        if (componentType === null)
            throw new Error("The parameter 'componentType' cannot be null.");
        else if (componentType !== undefined)
            url_ += "componentType=" + encodeURIComponent("" + componentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNetstationComponentDetails(_response);
        });
    }

    protected processNetstationComponentDetails(response: Response): Promise<ComponentDetailResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComponentDetailResponseDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComponentDetailResponseDTO>(null as any);
    }

    /**
     * Update access information for assets
     * @param type (optional) 
     * @param body (optional) 
     * @return OK
     */
    accessConditionsPUT(type: AssetType2 | undefined, body: UpdateAccessConditionsDTO | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Asset/AccessConditions?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAccessConditionsPUT(_response);
        });
    }

    protected processAccessConditionsPUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Add access information for assets
     * @param type (optional) 
     * @param body (optional) 
     * @return OK
     */
    accessConditionsPOST(type: AssetType2 | undefined, body: AddAccessConditionsDTO | undefined, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/Asset/AccessConditions?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAccessConditionsPOST(_response);
        });
    }

    protected processAccessConditionsPOST(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Mass lookup assets
     * @param body (optional) 
     * @return OK
     */
    massLookup(body: MassLookupDTO | undefined, signal?: AbortSignal): Promise<MassLookupResponseDTO> {
        let url_ = this.baseUrl + "/Asset/MassLookup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMassLookup(_response);
        });
    }

    protected processMassLookup(response: Response): Promise<MassLookupResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MassLookupResponseDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MassLookupResponseDTO>(null as any);
    }

    /**
     * @return OK
     */
    attachmentsAll(taskId: number, signal?: AbortSignal): Promise<AttachmentDTO[]> {
        let url_ = this.baseUrl + "/tasks/{taskId}/Attachments";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAttachmentsAll(_response);
        });
    }

    protected processAttachmentsAll(response: Response): Promise<AttachmentDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AttachmentDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentDTO[]>(null as any);
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    attachmentsPOST(taskId: number, file: FileParameter | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/tasks/{taskId}/Attachments";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAttachmentsPOST(_response);
        });
    }

    protected processAttachmentsPOST(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    numberOfFiles(taskId: number, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/tasks/{taskId}/Attachments/numberOfFiles";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNumberOfFiles(_response);
        });
    }

    protected processNumberOfFiles(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    attachmentsGET(taskId: number, filename: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/tasks/{taskId}/Attachments/{filename}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAttachmentsGET(_response);
        });
    }

    protected processAttachmentsGET(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    attachmentsDELETE(taskId: number, filename: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/tasks/{taskId}/Attachments/{filename}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAttachmentsDELETE(_response);
        });
    }

    protected processAttachmentsDELETE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    thumbnail(taskId: number, filename: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/tasks/{taskId}/Attachments/thumbnail/{filename}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processThumbnail(_response);
        });
    }

    protected processThumbnail(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    comments(body: CommentDTO | undefined, signal?: AbortSignal): Promise<CommentDTO> {
        let url_ = this.baseUrl + "/Comments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processComments(_response);
        });
    }

    protected processComments(response: Response): Promise<CommentDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommentDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommentDTO>(null as any);
    }

    /**
     * @param commentId (optional) 
     * @param workTaskId (optional) 
     * @param flag (optional) 
     * @return OK
     */
    flagComment(commentId: number | undefined, workTaskId: number | undefined, flag: boolean | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Comments/FlagComment?";
        if (commentId === null)
            throw new Error("The parameter 'commentId' cannot be null.");
        else if (commentId !== undefined)
            url_ += "commentId=" + encodeURIComponent("" + commentId) + "&";
        if (workTaskId === null)
            throw new Error("The parameter 'workTaskId' cannot be null.");
        else if (workTaskId !== undefined)
            url_ += "workTaskId=" + encodeURIComponent("" + workTaskId) + "&";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFlagComment(_response);
        });
    }

    protected processFlagComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return OK
     */
    isOrderValidForConsumption(orderId: number | undefined, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/Consumption/isOrderValidForConsumption?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsOrderValidForConsumption(_response);
        });
    }

    protected processIsOrderValidForConsumption(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return OK
     */
    getItemsForConsumption(orderId: number | undefined, signal?: AbortSignal): Promise<ConsumableItemsDTO> {
        let url_ = this.baseUrl + "/Consumption/itemsForConsumption?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemsForConsumption(_response);
        });
    }

    protected processGetItemsForConsumption(response: Response): Promise<ConsumableItemsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConsumableItemsDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsumableItemsDTO>(null as any);
    }

    /**
     * @param orderId (optional) 
     * @param body (optional) 
     * @return OK
     */
    consumeItemsOnOrder(orderId: number | undefined, body: CreateItemConsumptionDTO | undefined, signal?: AbortSignal): Promise<ExcessItemsDTO> {
        let url_ = this.baseUrl + "/Consumption/ConsumeItemsOnOrder?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConsumeItemsOnOrder(_response);
        });
    }

    protected processConsumeItemsOnOrder(response: Response): Promise<ExcessItemsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExcessItemsDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExcessItemsDTO>(null as any);
    }

    /**
     * @return OK
     */
    departmentAll(signal?: AbortSignal): Promise<DepartmentDTO[]> {
        let url_ = this.baseUrl + "/Department";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDepartmentAll(_response);
        });
    }

    protected processDepartmentAll(response: Response): Promise<DepartmentDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DepartmentDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DepartmentDTO[]>(null as any);
    }

    /**
     * @param name (optional) 
     * @return OK
     */
    department(name: string | undefined, signal?: AbortSignal): Promise<DepartmentDTO> {
        let url_ = this.baseUrl + "/Department?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDepartment(_response);
        });
    }

    protected processDepartment(response: Response): Promise<DepartmentDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DepartmentDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DepartmentDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateDepartment(body: DepartmentDTO | undefined, signal?: AbortSignal): Promise<DepartmentDTO> {
        let url_ = this.baseUrl + "/Department";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateDepartment(_response);
        });
    }

    protected processUpdateDepartment(response: Response): Promise<DepartmentDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DepartmentDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DepartmentDTO>(null as any);
    }

    /**
     * @return OK
     */
    getAllDepartments(signal?: AbortSignal): Promise<DepartmentDTO[]> {
        let url_ = this.baseUrl + "/Department/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllDepartments(_response);
        });
    }

    protected processGetAllDepartments(response: Response): Promise<DepartmentDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DepartmentDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DepartmentDTO[]>(null as any);
    }

    /**
     * @param assetId (optional) 
     * @return OK
     */
    fieldMeasurementAll(assetId: string | undefined, signal?: AbortSignal): Promise<FieldMeasurementDTO[]> {
        let url_ = this.baseUrl + "/FieldMeasurement?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFieldMeasurementAll(_response);
        });
    }

    protected processFieldMeasurementAll(response: Response): Promise<FieldMeasurementDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FieldMeasurementDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FieldMeasurementDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fieldMeasurement(body: CreateFieldMeasurementDTO | undefined, signal?: AbortSignal): Promise<FieldMeasurementDTO> {
        let url_ = this.baseUrl + "/FieldMeasurement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFieldMeasurement(_response);
        });
    }

    protected processFieldMeasurement(response: Response): Promise<FieldMeasurementDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FieldMeasurementDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FieldMeasurementDTO>(null as any);
    }

    /**
     * @return OK
     */
    gisComponentChange(workTaskId: number, signal?: AbortSignal): Promise<GisChangeInfoDTO> {
        let url_ = this.baseUrl + "/GisComponentChange/{workTaskId}";
        if (workTaskId === undefined || workTaskId === null)
            throw new Error("The parameter 'workTaskId' must be defined.");
        url_ = url_.replace("{workTaskId}", encodeURIComponent("" + workTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGisComponentChange(_response);
        });
    }

    protected processGisComponentChange(response: Response): Promise<GisChangeInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GisChangeInfoDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GisChangeInfoDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    componentCommentPOST(body: ComponentCommentRequestDTO | undefined, signal?: AbortSignal): Promise<ComponentCommentResponseDTO> {
        let url_ = this.baseUrl + "/GisComponentChange/ComponentComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processComponentCommentPOST(_response);
        });
    }

    protected processComponentCommentPOST(response: Response): Promise<ComponentCommentResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComponentCommentResponseDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComponentCommentResponseDTO>(null as any);
    }

    /**
     * @param componentCommentId (optional) 
     * @return OK
     */
    componentCommentDELETE(componentCommentId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/GisComponentChange/ComponentComment?";
        if (componentCommentId === null)
            throw new Error("The parameter 'componentCommentId' cannot be null.");
        else if (componentCommentId !== undefined)
            url_ += "componentCommentId=" + encodeURIComponent("" + componentCommentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processComponentCommentDELETE(_response);
        });
    }

    protected processComponentCommentDELETE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    componentFieldChange(body: ComponentFieldChangeDTO | undefined, signal?: AbortSignal): Promise<ComponentFieldChangeDTO> {
        let url_ = this.baseUrl + "/GisComponentChange/ComponentFieldChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processComponentFieldChange(_response);
        });
    }

    protected processComponentFieldChange(response: Response): Promise<ComponentFieldChangeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComponentFieldChangeDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComponentFieldChangeDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    listViewCommentPOST(body: ListViewCommentRequestDTO | undefined, signal?: AbortSignal): Promise<ListViewCommentResponseDTO> {
        let url_ = this.baseUrl + "/GisComponentChange/ListViewComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListViewCommentPOST(_response);
        });
    }

    protected processListViewCommentPOST(response: Response): Promise<ListViewCommentResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListViewCommentResponseDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListViewCommentResponseDTO>(null as any);
    }

    /**
     * @param listViewCommentId (optional) 
     * @return OK
     */
    listViewCommentDELETE(listViewCommentId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/GisComponentChange/ListViewComment?";
        if (listViewCommentId === null)
            throw new Error("The parameter 'listViewCommentId' cannot be null.");
        else if (listViewCommentId !== undefined)
            url_ += "listViewCommentId=" + encodeURIComponent("" + listViewCommentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListViewCommentDELETE(_response);
        });
    }

    protected processListViewCommentDELETE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    hasChanges(workTaskId: number, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/GisComponentChange/HasChanges/{workTaskId}";
        if (workTaskId === undefined || workTaskId === null)
            throw new Error("The parameter 'workTaskId' must be defined.");
        url_ = url_.replace("{workTaskId}", encodeURIComponent("" + workTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHasChanges(_response);
        });
    }

    protected processHasChanges(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    componentFileUploadData(body: ComponentFileUploadRequestDTO | undefined, signal?: AbortSignal): Promise<ComponentFileUploadResponseDTO> {
        let url_ = this.baseUrl + "/GisComponentChange/ComponentFileUploadData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processComponentFileUploadData(_response);
        });
    }

    protected processComponentFileUploadData(response: Response): Promise<ComponentFileUploadResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComponentFileUploadResponseDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComponentFileUploadResponseDTO>(null as any);
    }

    /**
     * @param workTaskId (optional) 
     * @param assetId (optional) 
     * @param componentId (optional) 
     * @param file (optional) 
     * @return OK
     */
    componentFileUploadPOST(workTaskId: number | undefined, assetId: string | undefined, componentId: string | undefined, file: FileParameter | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/GisComponentChange/ComponentFileUpload?";
        if (workTaskId === null)
            throw new Error("The parameter 'workTaskId' cannot be null.");
        else if (workTaskId !== undefined)
            url_ += "workTaskId=" + encodeURIComponent("" + workTaskId) + "&";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (componentId === null)
            throw new Error("The parameter 'componentId' cannot be null.");
        else if (componentId !== undefined)
            url_ += "componentId=" + encodeURIComponent("" + componentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processComponentFileUploadPOST(_response);
        });
    }

    protected processComponentFileUploadPOST(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param workTaskId (optional) 
     * @param assetId (optional) 
     * @param componentId (optional) 
     * @param fileName (optional) 
     * @return OK
     */
    componentFileUploadGET(workTaskId: number | undefined, assetId: string | undefined, componentId: string | undefined, fileName: string | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/GisComponentChange/ComponentFileUpload?";
        if (workTaskId === null)
            throw new Error("The parameter 'workTaskId' cannot be null.");
        else if (workTaskId !== undefined)
            url_ += "workTaskId=" + encodeURIComponent("" + workTaskId) + "&";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (componentId === null)
            throw new Error("The parameter 'componentId' cannot be null.");
        else if (componentId !== undefined)
            url_ += "componentId=" + encodeURIComponent("" + componentId) + "&";
        if (fileName === null)
            throw new Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processComponentFileUploadGET(_response);
        });
    }

    protected processComponentFileUploadGET(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param fileUploadId (optional) 
     * @return OK
     */
    componentFileUploadDELETE(fileUploadId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/GisComponentChange/ComponentFileUpload?";
        if (fileUploadId === null)
            throw new Error("The parameter 'fileUploadId' cannot be null.");
        else if (fileUploadId !== undefined)
            url_ += "fileUploadId=" + encodeURIComponent("" + fileUploadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processComponentFileUploadDELETE(_response);
        });
    }

    protected processComponentFileUploadDELETE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param workTaskId (optional) 
     * @param assetId (optional) 
     * @param componentId (optional) 
     * @param fileName (optional) 
     * @return OK
     */
    componentThumbnail(workTaskId: number | undefined, assetId: string | undefined, componentId: string | undefined, fileName: string | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/GisComponentChange/ComponentThumbnail?";
        if (workTaskId === null)
            throw new Error("The parameter 'workTaskId' cannot be null.");
        else if (workTaskId !== undefined)
            url_ += "workTaskId=" + encodeURIComponent("" + workTaskId) + "&";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (componentId === null)
            throw new Error("The parameter 'componentId' cannot be null.");
        else if (componentId !== undefined)
            url_ += "componentId=" + encodeURIComponent("" + componentId) + "&";
        if (fileName === null)
            throw new Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processComponentThumbnail(_response);
        });
    }

    protected processComponentThumbnail(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    listViewFileUploadData(body: ListViewFileUploadRequestDTO | undefined, signal?: AbortSignal): Promise<ListViewFileUploadResponseDTO> {
        let url_ = this.baseUrl + "/GisComponentChange/ListViewFileUploadData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListViewFileUploadData(_response);
        });
    }

    protected processListViewFileUploadData(response: Response): Promise<ListViewFileUploadResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListViewFileUploadResponseDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListViewFileUploadResponseDTO>(null as any);
    }

    /**
     * @param workTaskId (optional) 
     * @param assetId (optional) 
     * @param file (optional) 
     * @return OK
     */
    listViewFileUploadFilePOST(workTaskId: number | undefined, assetId: string | undefined, file: FileParameter | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/GisComponentChange/ListViewFileUploadFile?";
        if (workTaskId === null)
            throw new Error("The parameter 'workTaskId' cannot be null.");
        else if (workTaskId !== undefined)
            url_ += "workTaskId=" + encodeURIComponent("" + workTaskId) + "&";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListViewFileUploadFilePOST(_response);
        });
    }

    protected processListViewFileUploadFilePOST(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param workTaskId (optional) 
     * @param assetId (optional) 
     * @param fileName (optional) 
     * @return OK
     */
    listViewFileUploadFileGET(workTaskId: number | undefined, assetId: string | undefined, fileName: string | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/GisComponentChange/ListViewFileUploadFile?";
        if (workTaskId === null)
            throw new Error("The parameter 'workTaskId' cannot be null.");
        else if (workTaskId !== undefined)
            url_ += "workTaskId=" + encodeURIComponent("" + workTaskId) + "&";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (fileName === null)
            throw new Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListViewFileUploadFileGET(_response);
        });
    }

    protected processListViewFileUploadFileGET(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param workTaskId (optional) 
     * @param assetId (optional) 
     * @param fileName (optional) 
     * @return OK
     */
    listViewThumbnail(workTaskId: number | undefined, assetId: string | undefined, fileName: string | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/GisComponentChange/ListViewThumbnail?";
        if (workTaskId === null)
            throw new Error("The parameter 'workTaskId' cannot be null.");
        else if (workTaskId !== undefined)
            url_ += "workTaskId=" + encodeURIComponent("" + workTaskId) + "&";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (fileName === null)
            throw new Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListViewThumbnail(_response);
        });
    }

    protected processListViewThumbnail(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param fileUploadId (optional) 
     * @return OK
     */
    listViewFileUpload(fileUploadId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/GisComponentChange/ListViewFileUpload?";
        if (fileUploadId === null)
            throw new Error("The parameter 'fileUploadId' cannot be null.");
        else if (fileUploadId !== undefined)
            url_ += "fileUploadId=" + encodeURIComponent("" + fileUploadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListViewFileUpload(_response);
        });
    }

    protected processListViewFileUpload(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    internalTasks(body: CreateInternalTaskDTO | undefined, signal?: AbortSignal): Promise<InternalTaskDTO> {
        let url_ = this.baseUrl + "/InternalTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInternalTasks(_response);
        });
    }

    protected processInternalTasks(response: Response): Promise<InternalTaskDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InternalTaskDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InternalTaskDTO>(null as any);
    }

    /**
     * @return OK
     */
    internalTasksAll(signal?: AbortSignal): Promise<InternalTaskDTO[]> {
        let url_ = this.baseUrl + "/InternalTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInternalTasksAll(_response);
        });
    }

    protected processInternalTasksAll(response: Response): Promise<InternalTaskDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InternalTaskDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InternalTaskDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setInternalTaskStatus(body: WorkTaskStatusDTO[] | undefined, signal?: AbortSignal): Promise<WorkTaskStatusDTO[]> {
        let url_ = this.baseUrl + "/InternalTasks/SetInternalTaskStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetInternalTaskStatus(_response);
        });
    }

    protected processSetInternalTaskStatus(response: Response): Promise<WorkTaskStatusDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkTaskStatusDTO[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkTaskStatusDTO[]>(null as any);
    }

    sendInternalTasksToPlanning(body: number[] | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/InternalTasks/SendInternalTasksToPlanning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendInternalTasksToPlanning(_response);
        });
    }

    protected processSendInternalTasksToPlanning(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    numberOfStatusCreatedInternalTasks(signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/InternalTasks/NumberOfStatusCreatedInternalTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNumberOfStatusCreatedInternalTasks(_response);
        });
    }

    protected processNumberOfStatusCreatedInternalTasks(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addFavoriteItem(body: AddFavoriteItemRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Item/favorites/addItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddFavoriteItem(_response);
        });
    }

    protected processAddFavoriteItem(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param groupName (optional) 
     * @return OK
     */
    createFavoriteItemGroup(groupName: string | undefined, signal?: AbortSignal): Promise<FavoriteItemGroupDTO> {
        let url_ = this.baseUrl + "/Item/favorites/createItemGroup?";
        if (groupName === null)
            throw new Error("The parameter 'groupName' cannot be null.");
        else if (groupName !== undefined)
            url_ += "groupName=" + encodeURIComponent("" + groupName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateFavoriteItemGroup(_response);
        });
    }

    protected processCreateFavoriteItemGroup(response: Response): Promise<FavoriteItemGroupDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FavoriteItemGroupDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FavoriteItemGroupDTO>(null as any);
    }

    /**
     * @return OK
     */
    getFavoriteItemGroups(signal?: AbortSignal): Promise<FavoriteItemGroupDTO[]> {
        let url_ = this.baseUrl + "/Item/favorites/getItemGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFavoriteItemGroups(_response);
        });
    }

    protected processGetFavoriteItemGroups(response: Response): Promise<FavoriteItemGroupDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FavoriteItemGroupDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FavoriteItemGroupDTO[]>(null as any);
    }

    /**
     * @param itemId (optional) 
     * @return OK
     */
    deleteFavoriteItem(itemId: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Item/favorites/DeleteItem?";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteFavoriteItem(_response);
        });
    }

    protected processDeleteFavoriteItem(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param groupId (optional) 
     * @return OK
     */
    deleteFavoriteItemGroup(groupId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Item/favorites/DeleteItemGroup?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteFavoriteItemGroup(_response);
        });
    }

    protected processDeleteFavoriteItemGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    reportItemImage(body: ItemImageReportDTO | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Item/reportItemImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReportItemImage(_response);
        });
    }

    protected processReportItemImage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getItemCounting(signal?: AbortSignal): Promise<ItemCountingDTO> {
        let url_ = this.baseUrl + "/ItemCounting/GetItemCounting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemCounting(_response);
        });
    }

    protected processGetItemCounting(response: Response): Promise<ItemCountingDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ItemCountingDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ItemCountingDTO>(null as any);
    }

    /**
     * @return OK
     */
    deleteItemCounting(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/ItemCounting/DeleteItemCounting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteItemCounting(_response);
        });
    }

    protected processDeleteItemCounting(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addItemCountingLine(body: ItemCountingLineDTO | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/ItemCounting/AddItemCountingLine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddItemCountingLine(_response);
        });
    }

    protected processAddItemCountingLine(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateItemCountingLine(body: ItemCountingLineDTO | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/ItemCounting/UpdateItemCountingLine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateItemCountingLine(_response);
        });
    }

    protected processUpdateItemCountingLine(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param itemId (optional) 
     * @return OK
     */
    deleteItemCountingLine(itemId: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/ItemCounting/DeleteItemCountingLine?";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteItemCountingLine(_response);
        });
    }

    protected processDeleteItemCountingLine(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    submitItemCounting(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/ItemCounting/SubmitItemCounting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitItemCounting(_response);
        });
    }

    protected processSubmitItemCounting(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param worktaskId (optional) 
     * @return OK
     */
    getAllMessages(worktaskId: number | undefined, signal?: AbortSignal): Promise<MessageDTO[]> {
        let url_ = this.baseUrl + "/Message/GetAllMessages?";
        if (worktaskId === null)
            throw new Error("The parameter 'worktaskId' cannot be null.");
        else if (worktaskId !== undefined)
            url_ += "worktaskId=" + encodeURIComponent("" + worktaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllMessages(_response);
        });
    }

    protected processGetAllMessages(response: Response): Promise<MessageDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MessageDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    getMeterTaskInfo(workTaskId: number, signal?: AbortSignal): Promise<MeterTaskInfoDTO> {
        let url_ = this.baseUrl + "/MeterTasks/{workTaskId}/GetMeterTaskInfo";
        if (workTaskId === undefined || workTaskId === null)
            throw new Error("The parameter 'workTaskId' must be defined.");
        url_ = url_.replace("{workTaskId}", encodeURIComponent("" + workTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMeterTaskInfo(_response);
        });
    }

    protected processGetMeterTaskInfo(response: Response): Promise<MeterTaskInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MeterTaskInfoDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeterTaskInfoDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addContactInfo(workTaskId: number, body: ContactInfoDto | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/MeterTasks/{workTaskId}/AddContactInfo";
        if (workTaskId === undefined || workTaskId === null)
            throw new Error("The parameter 'workTaskId' must be defined.");
        url_ = url_.replace("{workTaskId}", encodeURIComponent("" + workTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddContactInfo(_response);
        });
    }

    protected processAddContactInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates whether a meter should be replaced or not on a meter task.
     * @param replaceMeter (optional) 
     * @return OK
     */
    updateReplaceMeter(workTaskId: number, replaceMeter: boolean | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/MeterTasks/{workTaskId}/ReplaceMeter?";
        if (workTaskId === undefined || workTaskId === null)
            throw new Error("The parameter 'workTaskId' must be defined.");
        url_ = url_.replace("{workTaskId}", encodeURIComponent("" + workTaskId));
        if (replaceMeter === null)
            throw new Error("The parameter 'replaceMeter' cannot be null.");
        else if (replaceMeter !== undefined)
            url_ += "replaceMeter=" + encodeURIComponent("" + replaceMeter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateReplaceMeter(_response);
        });
    }

    protected processUpdateReplaceMeter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get Latest By User
     * @return OK
     */
    getByUser(signal?: AbortSignal): Promise<NewsDTO[]> {
        let url_ = this.baseUrl + "/News/GetByUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByUser(_response);
        });
    }

    protected processGetByUser(response: Response): Promise<NewsDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewsDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewsDTO[]>(null as any);
    }

    /**
     * Get All News
     * @return OK
     */
    getAll(signal?: AbortSignal): Promise<NewsDTO[]> {
        let url_ = this.baseUrl + "/News/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<NewsDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewsDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewsDTO[]>(null as any);
    }

    /**
     * Get Unread Total
     * @return OK
     */
    getUnreadTotal(signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/News/GetUnreadTotal";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnreadTotal(_response);
        });
    }

    protected processGetUnreadTotal(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Read News
     * @param newsId (optional) 
     * @return OK
     */
    readNews(newsId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/News/ReadNews?";
        if (newsId === null)
            throw new Error("The parameter 'newsId' cannot be null.");
        else if (newsId !== undefined)
            url_ += "newsId=" + encodeURIComponent("" + newsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReadNews(_response);
        });
    }

    protected processReadNews(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createNews(body: CreateNewsDTO | undefined, signal?: AbortSignal): Promise<NewsDTO> {
        let url_ = this.baseUrl + "/News";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateNews(_response);
        });
    }

    protected processCreateNews(response: Response): Promise<NewsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewsDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewsDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateNews(body: UpdateNewsDTO | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/News";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateNews(_response);
        });
    }

    protected processUpdateNews(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param newsId (optional) 
     * @return OK
     */
    deleteNews(newsId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/News?";
        if (newsId === null)
            throw new Error("The parameter 'newsId' cannot be null.");
        else if (newsId !== undefined)
            url_ += "newsId=" + encodeURIComponent("" + newsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteNews(_response);
        });
    }

    protected processDeleteNews(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @return OK
     */
    getActiveOrdersByWarehouse(warehouseId: string | undefined, signal?: AbortSignal): Promise<OrderDTO[]> {
        let url_ = this.baseUrl + "/Order/activeOrdersByWarehouse?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActiveOrdersByWarehouse(_response);
        });
    }

    protected processGetActiveOrdersByWarehouse(response: Response): Promise<OrderDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrderDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    getActiveOrdersByUser(signal?: AbortSignal): Promise<OrderDTO[]> {
        let url_ = this.baseUrl + "/Order/activeOrdersByUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActiveOrdersByUser(_response);
        });
    }

    protected processGetActiveOrdersByUser(response: Response): Promise<OrderDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrderDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderDTO[]>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @return OK
     * @deprecated
     */
    getActiveOrders(warehouseId: string | undefined, signal?: AbortSignal): Promise<TransferOrderDTO[]> {
        let url_ = this.baseUrl + "/Order/activeOrder?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActiveOrders(_response);
        });
    }

    protected processGetActiveOrders(response: Response): Promise<TransferOrderDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransferOrderDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransferOrderDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createTransferOrder(body: CreateTransferOrderDTO | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Order/transferOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateTransferOrder(_response);
        });
    }

    protected processCreateTransferOrder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createTransferJournal(body: CreateTransferJournalDTO | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Order/transferJournal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateTransferJournal(_response);
        });
    }

    protected processCreateTransferJournal(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param consignorId (optional) 
     * @return OK
     * @deprecated
     */
    createItemMove(consignorId: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Order/itemMove?";
        if (consignorId === null)
            throw new Error("The parameter 'consignorId' cannot be null.");
        else if (consignorId !== undefined)
            url_ += "consignorId=" + encodeURIComponent("" + consignorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateItemMove(_response);
        });
    }

    protected processCreateItemMove(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return OK
     */
    moveToVehicle(orderId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Order/moveToVehicle?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMoveToVehicle(_response);
        });
    }

    protected processMoveToVehicle(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @return OK
     */
    geReturnOrders(warehouseId: string | undefined, signal?: AbortSignal): Promise<TransferOrderDTO[]> {
        let url_ = this.baseUrl + "/Order/returnOrders?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGeReturnOrders(_response);
        });
    }

    protected processGeReturnOrders(response: Response): Promise<TransferOrderDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransferOrderDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransferOrderDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createReturnOrder(body: CreateReturnOrderDTO | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Order/returnOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateReturnOrder(_response);
        });
    }

    protected processCreateReturnOrder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getOrdersForWorkplan(worktaskId: number, signal?: AbortSignal): Promise<WorkplanOrderDTO[]> {
        let url_ = this.baseUrl + "/Order/ordersForWorkplan/{worktaskId}";
        if (worktaskId === undefined || worktaskId === null)
            throw new Error("The parameter 'worktaskId' must be defined.");
        url_ = url_.replace("{worktaskId}", encodeURIComponent("" + worktaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrdersForWorkplan(_response);
        });
    }

    protected processGetOrdersForWorkplan(response: Response): Promise<WorkplanOrderDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkplanOrderDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkplanOrderDTO[]>(null as any);
    }

    /**
     * @param transferId (optional) 
     * @return OK
     */
    getOrderInfoByTransferId(transferId: string | undefined, signal?: AbortSignal): Promise<OrderDTO> {
        let url_ = this.baseUrl + "/Order/getOrderInfoByTransferId?";
        if (transferId === null)
            throw new Error("The parameter 'transferId' cannot be null.");
        else if (transferId !== undefined)
            url_ += "transferId=" + encodeURIComponent("" + transferId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrderInfoByTransferId(_response);
        });
    }

    protected processGetOrderInfoByTransferId(response: Response): Promise<OrderDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrderDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderDTO>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @return OK
     */
    getMrpOrdersByWarehouse(warehouseId: string | undefined, signal?: AbortSignal): Promise<OrderDTO[]> {
        let url_ = this.baseUrl + "/Order/MrpOrdersByWarehouse?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMrpOrdersByWarehouse(_response);
        });
    }

    protected processGetMrpOrdersByWarehouse(response: Response): Promise<OrderDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrderDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderDTO[]>(null as any);
    }

    /**
     * @param taskTypeId (optional) 
     * @return OK
     */
    getOrderedItems(taskTypeId: number | undefined, signal?: AbortSignal): Promise<OrderItemDTO2[]> {
        let url_ = this.baseUrl + "/Order/GetOrderedItems?";
        if (taskTypeId === null)
            throw new Error("The parameter 'taskTypeId' cannot be null.");
        else if (taskTypeId !== undefined)
            url_ += "taskTypeId=" + encodeURIComponent("" + taskTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrderedItems(_response);
        });
    }

    protected processGetOrderedItems(response: Response): Promise<OrderItemDTO2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrderItemDTO2[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderItemDTO2[]>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param contractorAgreementId (optional) 
     * @return OK
     */
    getPDFV2(taskId: number | undefined, contractorAgreementId: number | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Pdf/GetPDFV2?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (contractorAgreementId === null)
            throw new Error("The parameter 'contractorAgreementId' cannot be null.");
        else if (contractorAgreementId !== undefined)
            url_ += "ContractorAgreementId=" + encodeURIComponent("" + contractorAgreementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPDFV2(_response);
        });
    }

    protected processGetPDFV2(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    getAllPortalLinks(signal?: AbortSignal): Promise<PortalLinkDto[]> {
        let url_ = this.baseUrl + "/PortalLink";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllPortalLinks(_response);
        });
    }

    protected processGetAllPortalLinks(response: Response): Promise<PortalLinkDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortalLinkDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortalLinkDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createPortalLink(body: CreatePortalLinkDto | undefined, signal?: AbortSignal): Promise<PortalLinkDto> {
        let url_ = this.baseUrl + "/PortalLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePortalLink(_response);
        });
    }

    protected processCreatePortalLink(response: Response): Promise<PortalLinkDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortalLinkDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortalLinkDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateOrderNumbers(body: PortalLinkDto[] | undefined, signal?: AbortSignal): Promise<PortalLinkDto[]> {
        let url_ = this.baseUrl + "/PortalLink/update-order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateOrderNumbers(_response);
        });
    }

    protected processUpdateOrderNumbers(response: Response): Promise<PortalLinkDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortalLinkDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortalLinkDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updatePortalLink(id: number, body: CreatePortalLinkDto | undefined, signal?: AbortSignal): Promise<PortalLinkDto> {
        let url_ = this.baseUrl + "/PortalLink/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePortalLink(_response);
        });
    }

    protected processUpdatePortalLink(response: Response): Promise<PortalLinkDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortalLinkDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortalLinkDto>(null as any);
    }

    /**
     * @return OK
     */
    deletePortalLink(id: number, signal?: AbortSignal): Promise<PortalLinkDto> {
        let url_ = this.baseUrl + "/PortalLink/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeletePortalLink(_response);
        });
    }

    protected processDeletePortalLink(response: Response): Promise<PortalLinkDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortalLinkDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortalLinkDto>(null as any);
    }

    /**
     * @param searchTerm (optional) 
     * @return OK
     */
    searchProducts(searchTerm: string | undefined, signal?: AbortSignal): Promise<ProductDetailDTO[]> {
        let url_ = this.baseUrl + "/ProductCatalog/searchProducts?";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchProducts(_response);
        });
    }

    protected processSearchProducts(response: Response): Promise<ProductDetailDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductDetailDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductDetailDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    getAvailableProductsWithFavorites(signal?: AbortSignal): Promise<ProductDetailDTO[]> {
        let url_ = this.baseUrl + "/ProductCatalog/availableProductsWithFavorites";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableProductsWithFavorites(_response);
        });
    }

    protected processGetAvailableProductsWithFavorites(response: Response): Promise<ProductDetailDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductDetailDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductDetailDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    getAllProducts(signal?: AbortSignal): Promise<ProductDetailDTO[]> {
        let url_ = this.baseUrl + "/ProductCatalog/allProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllProducts(_response);
        });
    }

    protected processGetAllProducts(response: Response): Promise<ProductDetailDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductDetailDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductDetailDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    getProductImage(imageUrl: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/ProductImage/{imageUrl}";
        if (imageUrl === undefined || imageUrl === null)
            throw new Error("The parameter 'imageUrl' must be defined.");
        url_ = url_.replace("{imageUrl}", encodeURIComponent("" + imageUrl));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProductImage(_response);
        });
    }

    protected processGetProductImage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getProjectById(projectId: string | undefined, signal?: AbortSignal): Promise<ProjectDTO2> {
        let url_ = this.baseUrl + "/Projects/projectById?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProjectById(_response);
        });
    }

    protected processGetProjectById(response: Response): Promise<ProjectDTO2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectDTO2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDTO2>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    canRegisterTime(projectId: string | undefined, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/Projects/canRegisterTime?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCanRegisterTime(_response);
        });
    }

    protected processCanRegisterTime(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param worktaskId (optional) 
     * @return OK
     */
    getProjectByWorkTaskId(worktaskId: number | undefined, signal?: AbortSignal): Promise<ProjectDTO2> {
        let url_ = this.baseUrl + "/Projects/projectByWorkTaskId?";
        if (worktaskId === null)
            throw new Error("The parameter 'worktaskId' cannot be null.");
        else if (worktaskId !== undefined)
            url_ += "worktaskId=" + encodeURIComponent("" + worktaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProjectByWorkTaskId(_response);
        });
    }

    protected processGetProjectByWorkTaskId(response: Response): Promise<ProjectDTO2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectDTO2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDTO2>(null as any);
    }

    /**
     * If categoryId is null, all projects are returned.
     * @param categoryId (optional) 
     * @return OK
     */
    getAllProjectsByCategory(categoryId: string | undefined, signal?: AbortSignal): Promise<ProjectDTO2[]> {
        let url_ = this.baseUrl + "/allProjectsByCategory?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllProjectsByCategory(_response);
        });
    }

    protected processGetAllProjectsByCategory(response: Response): Promise<ProjectDTO2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectDTO2[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDTO2[]>(null as any);
    }

    /**
     * @return OK
     */
    qAGET(taskId: number, answerId: number, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/tasks/{taskId}/QA/{answerId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (answerId === undefined || answerId === null)
            throw new Error("The parameter 'answerId' must be defined.");
        url_ = url_.replace("{answerId}", encodeURIComponent("" + answerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQAGET(_response);
        });
    }

    protected processQAGET(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get work plan
     * @return OK
     */
    getWorkPlan5(signal?: AbortSignal): Promise<WorkPlanItemDTO[]> {
        let url_ = this.baseUrl + "/Schedule/WorkPlan5";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWorkPlan5(_response);
        });
    }

    protected processGetWorkPlan5(response: Response): Promise<WorkPlanItemDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkPlanItemDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkPlanItemDTO[]>(null as any);
    }

    /**
     * Get work plan
     * @return OK
     */
    getWorkPlan6(signal?: AbortSignal): Promise<GetWorkPlanDTO6> {
        let url_ = this.baseUrl + "/Schedule/WorkPlan6";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWorkPlan6(_response);
        });
    }

    protected processGetWorkPlan6(response: Response): Promise<GetWorkPlanDTO6> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetWorkPlanDTO6;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetWorkPlanDTO6>(null as any);
    }

    /**
     * Get all planned events on a given date
     * @param date (optional) 
     * @return OK
     */
    getPlanningEvents(date: string | undefined, signal?: AbortSignal): Promise<TechnicianScheduleDTO[]> {
        let url_ = this.baseUrl + "/Schedule/GetPlanningEvents?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPlanningEvents(_response);
        });
    }

    protected processGetPlanningEvents(response: Response): Promise<TechnicianScheduleDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TechnicianScheduleDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TechnicianScheduleDTO[]>(null as any);
    }

    /**
     * @param date (optional) 
     * @return OK
     */
    allAbsences(date: string | undefined, signal?: AbortSignal): Promise<AbsenceDTO[]> {
        let url_ = this.baseUrl + "/Schedule/allAbsences?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAllAbsences(_response);
        });
    }

    protected processAllAbsences(response: Response): Promise<AbsenceDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AbsenceDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AbsenceDTO[]>(null as any);
    }

    /**
     * Starts a drive to the booking
     * @return OK
     */
    driveToBooking(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Schedule/booking/{id}/driveToBooking";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDriveToBooking(_response);
        });
    }

    protected processDriveToBooking(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Technician leaves to booking
     * @return OK
     */
    leaveBooking(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Schedule/booking/{id}/leaveBooking";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLeaveBooking(_response);
        });
    }

    protected processLeaveBooking(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Technician starts working on booking
     * @return OK
     */
    startBooking(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Schedule/booking/{id}/startBooking";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStartBooking(_response);
        });
    }

    protected processStartBooking(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Close dialogue message for booking
     * @return OK
     */
    closeBookingDialog(id: number, signal?: AbortSignal): Promise<GetCloseBookingDialogueDTO> {
        let url_ = this.baseUrl + "/Schedule/booking/{id}/close-dialogue";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCloseBookingDialog(_response);
        });
    }

    protected processCloseBookingDialog(response: Response): Promise<GetCloseBookingDialogueDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCloseBookingDialogueDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCloseBookingDialogueDTO>(null as any);
    }

    /**
     * @return OK
     */
    getAllSelectedUsers(signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/SelectedUsers/GetAllSelectedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllSelectedUsers(_response);
        });
    }

    protected processGetAllSelectedUsers(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addSelectedUser(body: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/SelectedUsers/AddSelectedUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddSelectedUser(_response);
        });
    }

    protected processAddSelectedUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param selectedUserEmail (optional) 
     * @return OK
     */
    removeSelectedUser(selectedUserEmail: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/SelectedUsers/RemoveSelectedUser?";
        if (selectedUserEmail === null)
            throw new Error("The parameter 'selectedUserEmail' cannot be null.");
        else if (selectedUserEmail !== undefined)
            url_ += "selectedUserEmail=" + encodeURIComponent("" + selectedUserEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveSelectedUser(_response);
        });
    }

    protected processRemoveSelectedUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateSelectedUsers(body: string[] | undefined, signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/SelectedUsers/UpdateSelectedUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSelectedUsers(_response);
        });
    }

    protected processUpdateSelectedUsers(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Mark Sub Work Task as deleted
     * @param subWorkTaskId (optional) 
     * @return OK
     * @deprecated
     */
    deleteSubWorkTask(subWorkTaskId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/SubWorkTasks/deleteSubWorkTask?";
        if (subWorkTaskId === null)
            throw new Error("The parameter 'subWorkTaskId' cannot be null.");
        else if (subWorkTaskId !== undefined)
            url_ += "subWorkTaskId=" + encodeURIComponent("" + subWorkTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteSubWorkTask(_response);
        });
    }

    protected processDeleteSubWorkTask(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Cancel a subWorkTask
     * @param subWorkTaskId (optional) 
     * @return OK
     */
    cancelSubWorkTask(subWorkTaskId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/SubWorkTasks/CancelSubWorkTask?";
        if (subWorkTaskId === null)
            throw new Error("The parameter 'subWorkTaskId' cannot be null.");
        else if (subWorkTaskId !== undefined)
            url_ += "subWorkTaskId=" + encodeURIComponent("" + subWorkTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelSubWorkTask(_response);
        });
    }

    protected processCancelSubWorkTask(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create Sub Work Task for Work task
     * @param workTaskId (optional) 
     * @param taskTypeId (optional) 
     * @return OK
     */
    createSubWorkTask(workTaskId: number | undefined, taskTypeId: number | undefined, signal?: AbortSignal): Promise<SubWorkTaskDTO> {
        let url_ = this.baseUrl + "/SubWorkTasks/subWorkTask?";
        if (workTaskId === null)
            throw new Error("The parameter 'workTaskId' cannot be null.");
        else if (workTaskId !== undefined)
            url_ += "workTaskId=" + encodeURIComponent("" + workTaskId) + "&";
        if (taskTypeId === null)
            throw new Error("The parameter 'taskTypeId' cannot be null.");
        else if (taskTypeId !== undefined)
            url_ += "taskTypeId=" + encodeURIComponent("" + taskTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSubWorkTask(_response);
        });
    }

    protected processCreateSubWorkTask(response: Response): Promise<SubWorkTaskDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubWorkTaskDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubWorkTaskDTO>(null as any);
    }

    /**
     * Get Sub Work Task
     * @param id (optional) 
     * @return OK
     */
    getSubWorkTask3(id: number | undefined, signal?: AbortSignal): Promise<SubWorkTaskDetailedDTO2> {
        let url_ = this.baseUrl + "/SubWorkTasks/subWorkTask3?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSubWorkTask3(_response);
        });
    }

    protected processGetSubWorkTask3(response: Response): Promise<SubWorkTaskDetailedDTO2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubWorkTaskDetailedDTO2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubWorkTaskDetailedDTO2>(null as any);
    }

    /**
     * Get all tasks
     * @param body (optional) 
     * @return OK
     */
    taskListPOST(body: TaskListRequestDTO | undefined, signal?: AbortSignal): Promise<TaskListResponseDTO> {
        let url_ = this.baseUrl + "/TaskList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTaskListPOST(_response);
        });
    }

    protected processTaskListPOST(response: Response): Promise<TaskListResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskListResponseDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskListResponseDTO>(null as any);
    }

    /**
     * Get required information for rendering task list
     * @param departmentId (optional) 
     * @return OK
     */
    taskListGET(departmentId: number | undefined, signal?: AbortSignal): Promise<TaskListInfoDTO> {
        let url_ = this.baseUrl + "/TaskList?";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTaskListGET(_response);
        });
    }

    protected processTaskListGET(response: Response): Promise<TaskListInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskListInfoDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskListInfoDTO>(null as any);
    }

    /**
     * @return OK
     */
    getBaseTask2(id: number, signal?: AbortSignal): Promise<WorkTaskDTO2> {
        let url_ = this.baseUrl + "/Tasks/{id}/GetBaseTask2";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBaseTask2(_response);
        });
    }

    protected processGetBaseTask2(response: Response): Promise<WorkTaskDTO2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkTaskDTO2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkTaskDTO2>(null as any);
    }

    assignMeAsResponsible(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Tasks/{id}/AssignMeAsResponsible";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssignMeAsResponsible(_response);
        });
    }

    protected processAssignMeAsResponsible(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Hand "Foerste mand" over to another technician booked on the task
     * @param body (optional) 
     * @return OK
     */
    transferResponsibility(id: number, body: PersonDTO | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Tasks/{id}/TransferResponsibility";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTransferResponsibility(_response);
        });
    }

    protected processTransferResponsibility(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Technicians who can take over "Foerste mand" on the task
     * @return OK
     */
    getBookedTechnicians(id: number, signal?: AbortSignal): Promise<PersonDTO[]> {
        let url_ = this.baseUrl + "/Tasks/{id}/BookedTechnicians";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBookedTechnicians(_response);
        });
    }

    protected processGetBookedTechnicians(response: Response): Promise<PersonDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonDTO[]>(null as any);
    }

    /**
     * The bookings closing the task will settle
     * @return OK
     */
    getCloseTaskDialogue(id: number, signal?: AbortSignal): Promise<GetCloseWorkTaskDialogueDTO> {
        let url_ = this.baseUrl + "/Tasks/{id}/CloseTaskDialogue";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCloseTaskDialogue(_response);
        });
    }

    protected processGetCloseTaskDialogue(response: Response): Promise<GetCloseWorkTaskDialogueDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCloseWorkTaskDialogueDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCloseWorkTaskDialogueDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createWorkTask2(body: CreateWorkTaskDTO2 | undefined, signal?: AbortSignal): Promise<WorkTaskDTO2> {
        let url_ = this.baseUrl + "/Tasks/CreateWorkTask2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateWorkTask2(_response);
        });
    }

    protected processCreateWorkTask2(response: Response): Promise<WorkTaskDTO2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkTaskDTO2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkTaskDTO2>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateWorkTask2(taskId: number, body: UpdateWorkTaskDTO2 | undefined, signal?: AbortSignal): Promise<WorkTaskDTO2> {
        let url_ = this.baseUrl + "/Tasks/{taskId}/UpdateWorkTask2";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateWorkTask2(_response);
        });
    }

    protected processUpdateWorkTask2(response: Response): Promise<WorkTaskDTO2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkTaskDTO2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkTaskDTO2>(null as any);
    }

    /**
     * @param tagId (optional) 
     * @param body (optional) 
     * @return OK
     */
    setWorkTasksTag(tagId: number | undefined, body: number[] | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Tasks/SetWorkTasksTag?";
        if (tagId === null)
            throw new Error("The parameter 'tagId' cannot be null.");
        else if (tagId !== undefined)
            url_ += "tagId=" + encodeURIComponent("" + tagId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetWorkTasksTag(_response);
        });
    }

    protected processSetWorkTasksTag(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    batchDeleteWorkTasks(body: number[] | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Tasks/batchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBatchDeleteWorkTasks(_response);
        });
    }

    protected processBatchDeleteWorkTasks(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    batchCancelWorkTasks(body: number[] | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Tasks/batchCancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBatchCancelWorkTasks(_response);
        });
    }

    protected processBatchCancelWorkTasks(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAnswers(body: UpdateAnswerDTO[] | undefined, signal?: AbortSignal): Promise<UpdateAnswerDTO[]> {
        let url_ = this.baseUrl + "/Tasks/UpdateAnswers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAnswers(_response);
        });
    }

    protected processUpdateAnswers(response: Response): Promise<UpdateAnswerDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateAnswerDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateAnswerDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addFileAnswers(body: FileAnswerUploadDTO | undefined, signal?: AbortSignal): Promise<FileAnswerDTO[]> {
        let url_ = this.baseUrl + "/Tasks/AddFileAnswers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddFileAnswers(_response);
        });
    }

    protected processAddFileAnswers(response: Response): Promise<FileAnswerDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileAnswerDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileAnswerDTO[]>(null as any);
    }

    /**
     * @param workTaskId (optional) 
     * @param fileAnswerId (optional) 
     * @return OK
     */
    deleteFileAnswer(workTaskId: number | undefined, fileAnswerId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Tasks/DeleteFileAnswer?";
        if (workTaskId === null)
            throw new Error("The parameter 'workTaskId' cannot be null.");
        else if (workTaskId !== undefined)
            url_ += "workTaskId=" + encodeURIComponent("" + workTaskId) + "&";
        if (fileAnswerId === null)
            throw new Error("The parameter 'fileAnswerId' cannot be null.");
        else if (fileAnswerId !== undefined)
            url_ += "fileAnswerId=" + encodeURIComponent("" + fileAnswerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteFileAnswer(_response);
        });
    }

    protected processDeleteFileAnswer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param files (optional) 
     * @return OK
     */
    files(taskId: number, answerId: number, files: FileParameter[] | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Tasks/{taskId}/{answerId}/files";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (answerId === undefined || answerId === null)
            throw new Error("The parameter 'answerId' must be defined.");
        url_ = url_.replace("{answerId}", encodeURIComponent("" + answerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFiles(_response);
        });
    }

    protected processFiles(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param fileName (optional) 
     * @return OK
     */
    thumbnail2(taskId: number, fileName: string | undefined, answerId: number, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Tasks/{taskId}/{answerId}/thumbnail?";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (answerId === undefined || answerId === null)
            throw new Error("The parameter 'answerId' must be defined.");
        url_ = url_.replace("{answerId}", encodeURIComponent("" + answerId));
        if (fileName === null)
            throw new Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processThumbnail2(_response);
        });
    }

    protected processThumbnail2(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param fileName (optional) 
     * @return OK
     */
    file(taskId: number, fileName: string | undefined, answerId: number, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Tasks/{taskId}/{answerId}/file?";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (answerId === undefined || answerId === null)
            throw new Error("The parameter 'answerId' must be defined.");
        url_ = url_.replace("{answerId}", encodeURIComponent("" + answerId));
        if (fileName === null)
            throw new Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFile(_response);
        });
    }

    protected processFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendWorkTasksToPlanning(body: number[] | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Tasks/SendWorkTasksToPlanning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendWorkTasksToPlanning(_response);
        });
    }

    protected processSendWorkTasksToPlanning(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    planWithD365(body: number[] | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Tasks/PlanWithD365";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPlanWithD365(_response);
        });
    }

    protected processPlanWithD365(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setTaskStatus(body: WorkTaskStatusDTO[] | undefined, signal?: AbortSignal): Promise<WorkTaskStatusDTO[]> {
        let url_ = this.baseUrl + "/Tasks/SetTaskStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetTaskStatus(_response);
        });
    }

    protected processSetTaskStatus(response: Response): Promise<WorkTaskStatusDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkTaskStatusDTO[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkTaskStatusDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setWorkPlanTaskStatus(body: WorkPlanItemStatusDTO | undefined, signal?: AbortSignal): Promise<WorkPlanItemStatusDTO> {
        let url_ = this.baseUrl + "/Tasks/SetWorkPlanTaskStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetWorkPlanTaskStatus(_response);
        });
    }

    protected processSetWorkPlanTaskStatus(response: Response): Promise<WorkPlanItemStatusDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkPlanItemStatusDTO;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkPlanItemStatusDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    completeDayOfMultiDayTask(body: DayTaskDTO | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Tasks/CompleteDayOfMultiDayTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCompleteDayOfMultiDayTask(_response);
        });
    }

    protected processCompleteDayOfMultiDayTask(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param taskTypeId (optional) 
     * @param status (optional) 
     * @return OK
     */
    getReasonCodes(taskTypeId: number | undefined, status: WorkTaskStatus | undefined, signal?: AbortSignal): Promise<ReasonCodeDTO[]> {
        let url_ = this.baseUrl + "/Tasks/GetReasonCodes?";
        if (taskTypeId === null)
            throw new Error("The parameter 'taskTypeId' cannot be null.");
        else if (taskTypeId !== undefined)
            url_ += "taskTypeId=" + encodeURIComponent("" + taskTypeId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReasonCodes(_response);
        });
    }

    protected processGetReasonCodes(response: Response): Promise<ReasonCodeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReasonCodeDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReasonCodeDTO[]>(null as any);
    }

    /**
     * @param lat (optional) 
     * @param lng (optional) 
     * @param assetId (optional) 
     * @return OK
     */
    nearby3(lat: number | undefined, lng: number | undefined, assetId: string | undefined, signal?: AbortSignal): Promise<NearbyTasksDTO> {
        let url_ = this.baseUrl + "/Tasks/nearby3?";
        if (lat === null)
            throw new Error("The parameter 'lat' cannot be null.");
        else if (lat !== undefined)
            url_ += "lat=" + encodeURIComponent("" + lat) + "&";
        if (lng === null)
            throw new Error("The parameter 'lng' cannot be null.");
        else if (lng !== undefined)
            url_ += "lng=" + encodeURIComponent("" + lng) + "&";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNearby3(_response);
        });
    }

    protected processNearby3(response: Response): Promise<NearbyTasksDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NearbyTasksDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NearbyTasksDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setTaskDepartment2(body: WorkTaskDepartmentDTO2[] | undefined, signal?: AbortSignal): Promise<WorkTaskDepartmentDTO2[]> {
        let url_ = this.baseUrl + "/Tasks/SetTaskDepartment2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetTaskDepartment2(_response);
        });
    }

    protected processSetTaskDepartment2(response: Response): Promise<WorkTaskDepartmentDTO2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkTaskDepartmentDTO2[];
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkTaskDepartmentDTO2[]>(null as any);
    }

    /**
     * @param email (optional) 
     * @param name (optional) 
     * @param body (optional) 
     * @return OK
     */
    assignTasksToCaseWorker(email: string | undefined, name: string | undefined, body: number[] | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Tasks/AssignTasksToCaseWorker?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssignTasksToCaseWorker(_response);
        });
    }

    protected processAssignTasksToCaseWorker(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    createContractorAgreement(taskId: number, signal?: AbortSignal): Promise<ContractorAgreementDTO2> {
        let url_ = this.baseUrl + "/Tasks/{taskId}/ContractorAgreements";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateContractorAgreement(_response);
        });
    }

    protected processCreateContractorAgreement(response: Response): Promise<ContractorAgreementDTO2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContractorAgreementDTO2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractorAgreementDTO2>(null as any);
    }

    /**
     * @return OK
     */
    getContractorAgreements(taskId: number, signal?: AbortSignal): Promise<ContractorAgreementDTO2[]> {
        let url_ = this.baseUrl + "/Tasks/{taskId}/ContractorAgreements";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetContractorAgreements(_response);
        });
    }

    protected processGetContractorAgreements(response: Response): Promise<ContractorAgreementDTO2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContractorAgreementDTO2[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractorAgreementDTO2[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    editContractorAgreement2(taskId: number, body: ContractorAgreementDTO2 | undefined, signal?: AbortSignal): Promise<ContractorAgreementDTO2> {
        let url_ = this.baseUrl + "/Tasks/{taskId}/ContractorAgreement2";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditContractorAgreement2(_response);
        });
    }

    protected processEditContractorAgreement2(response: Response): Promise<ContractorAgreementDTO2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContractorAgreementDTO2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractorAgreementDTO2>(null as any);
    }

    /**
     * @return OK
     */
    deleteContractorAgreement(contractorAgreementId: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/ContractorAgreements/{contractorAgreementId}";
        if (contractorAgreementId === undefined || contractorAgreementId === null)
            throw new Error("The parameter 'contractorAgreementId' must be defined.");
        url_ = url_.replace("{contractorAgreementId}", encodeURIComponent("" + contractorAgreementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteContractorAgreement(_response);
        });
    }

    protected processDeleteContractorAgreement(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    customerAppointment(taskId: number, body: CustomerAppointmentBaseDTO | undefined, signal?: AbortSignal): Promise<CustomerAppointmentDTO> {
        let url_ = this.baseUrl + "/Tasks/{taskId}/CustomerAppointment";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCustomerAppointment(_response);
        });
    }

    protected processCustomerAppointment(response: Response): Promise<CustomerAppointmentDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerAppointmentDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerAppointmentDTO>(null as any);
    }

    /**
     * Get past and future tasks for a technician
     * @param from (optional) 
     * @param to (optional) 
     * @return OK
     */
    getTechnicianCalendarTasks(from: string | undefined, to: string | undefined, signal?: AbortSignal): Promise<WorkPlanItemDTO[]> {
        let url_ = this.baseUrl + "/Tasks/TechnicianCalendarTasks?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTechnicianCalendarTasks(_response);
        });
    }

    protected processGetTechnicianCalendarTasks(response: Response): Promise<WorkPlanItemDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkPlanItemDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkPlanItemDTO[]>(null as any);
    }

    /**
     * Get past and future bookings for a technician
     * @param from (optional) 
     * @param to (optional) 
     * @return OK
     */
    getTechnicianCalendarBookings(from: string | undefined, to: string | undefined, signal?: AbortSignal): Promise<GetWorkPlanDTO6> {
        let url_ = this.baseUrl + "/Tasks/TechnicianCalendarBookings?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTechnicianCalendarBookings(_response);
        });
    }

    protected processGetTechnicianCalendarBookings(response: Response): Promise<GetWorkPlanDTO6> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetWorkPlanDTO6;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetWorkPlanDTO6>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateProjectNumberForWorkTask(workTaskId: number, body: WorkTaskProjectDTO | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Tasks/{workTaskId}/project";
        if (workTaskId === undefined || workTaskId === null)
            throw new Error("The parameter 'workTaskId' must be defined.");
        url_ = url_.replace("{workTaskId}", encodeURIComponent("" + workTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProjectNumberForWorkTask(_response);
        });
    }

    protected processUpdateProjectNumberForWorkTask(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Perform a mass creation of worktasks
     * @param body (optional) 
     * @return OK
     */
    massCreateWorkTasks2(body: MassCreationRequestDTO2 | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Tasks/MassCreation2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMassCreateWorkTasks2(_response);
        });
    }

    protected processMassCreateWorkTasks2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Perform a mass creation of stretch worktasks
     * @param body (optional) 
     * @return OK
     */
    massCreateStretchWorkTasks(body: MassCreationStretchRequestDTO | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Tasks/MassCreationStretch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMassCreateStretchWorkTasks(_response);
        });
    }

    protected processMassCreateStretchWorkTasks(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    simulatePlanning(workTaskId: number, body: SimulateDto | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Tasks/{workTaskId}/SimulatePlanning";
        if (workTaskId === undefined || workTaskId === null)
            throw new Error("The parameter 'workTaskId' must be defined.");
        url_ = url_.replace("{workTaskId}", encodeURIComponent("" + workTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSimulatePlanning(_response);
        });
    }

    protected processSimulatePlanning(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    simulateBooking(workTaskId: number, body: SimulateDto | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Tasks/{workTaskId}/SimulateBooing";
        if (workTaskId === undefined || workTaskId === null)
            throw new Error("The parameter 'workTaskId' must be defined.");
        url_ = url_.replace("{workTaskId}", encodeURIComponent("" + workTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSimulateBooking(_response);
        });
    }

    protected processSimulateBooking(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param taskSectionId (optional) 
     * @return OK
     */
    deleteRepeatableSection(taskSectionId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Tasks/DeleteRepeatableSection?";
        if (taskSectionId === null)
            throw new Error("The parameter 'taskSectionId' cannot be null.");
        else if (taskSectionId !== undefined)
            url_ += "taskSectionId=" + encodeURIComponent("" + taskSectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRepeatableSection(_response);
        });
    }

    protected processDeleteRepeatableSection(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param notificationType (optional) 
     * @param subscribe (optional) 
     * @return OK
     */
    emailNotification(workTaskId: number, notificationType: EmailNotificationTypeEnum | undefined, subscribe: boolean | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Tasks/{workTaskId}/EmailNotification?";
        if (workTaskId === undefined || workTaskId === null)
            throw new Error("The parameter 'workTaskId' must be defined.");
        url_ = url_.replace("{workTaskId}", encodeURIComponent("" + workTaskId));
        if (notificationType === null)
            throw new Error("The parameter 'notificationType' cannot be null.");
        else if (notificationType !== undefined)
            url_ += "notificationType=" + encodeURIComponent("" + notificationType) + "&";
        if (subscribe === null)
            throw new Error("The parameter 'subscribe' cannot be null.");
        else if (subscribe !== undefined)
            url_ += "subscribe=" + encodeURIComponent("" + subscribe) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEmailNotification(_response);
        });
    }

    protected processEmailNotification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param notificationType (optional) 
     * @return OK
     */
    isSubscribed(workTaskId: number, notificationType: EmailNotificationTypeEnum | undefined, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/Tasks/{workTaskId}/EmailNotification/IsSubscribed?";
        if (workTaskId === undefined || workTaskId === null)
            throw new Error("The parameter 'workTaskId' must be defined.");
        url_ = url_.replace("{workTaskId}", encodeURIComponent("" + workTaskId));
        if (notificationType === null)
            throw new Error("The parameter 'notificationType' cannot be null.");
        else if (notificationType !== undefined)
            url_ += "notificationType=" + encodeURIComponent("" + notificationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsSubscribed(_response);
        });
    }

    protected processIsSubscribed(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Returns 204 NoContent if revisit is inexistent
     * @return OK
     */
    getRevisit(workTaskId: number, signal?: AbortSignal): Promise<RevisitDTO> {
        let url_ = this.baseUrl + "/Tasks/GetRevisit/{workTaskId}";
        if (workTaskId === undefined || workTaskId === null)
            throw new Error("The parameter 'workTaskId' must be defined.");
        url_ = url_.replace("{workTaskId}", encodeURIComponent("" + workTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRevisit(_response);
        });
    }

    protected processGetRevisit(response: Response): Promise<RevisitDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RevisitDTO;
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("No Content", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RevisitDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createRevisit(body: RevisitDTO | undefined, signal?: AbortSignal): Promise<RevisitDTO> {
        let url_ = this.baseUrl + "/Tasks/CreateRevisit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRevisit(_response);
        });
    }

    protected processCreateRevisit(response: Response): Promise<RevisitDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RevisitDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RevisitDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateRevisit(body: RevisitDTO | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Tasks/UpdateRevisit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateRevisit(_response);
        });
    }

    protected processUpdateRevisit(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param workTaskId (optional) 
     * @return OK
     */
    deleteRevisit(workTaskId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Tasks/DeleteRevisit?";
        if (workTaskId === null)
            throw new Error("The parameter 'workTaskId' cannot be null.");
        else if (workTaskId !== undefined)
            url_ += "workTaskId=" + encodeURIComponent("" + workTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRevisit(_response);
        });
    }

    protected processDeleteRevisit(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createTaskType2(body: CreateAndUpdateTaskTypeDTO2 | undefined, signal?: AbortSignal): Promise<TaskTypeDetailedDTO2> {
        let url_ = this.baseUrl + "/TaskTypes/CreateTaskType2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateTaskType2(_response);
        });
    }

    protected processCreateTaskType2(response: Response): Promise<TaskTypeDetailedDTO2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskTypeDetailedDTO2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskTypeDetailedDTO2>(null as any);
    }

    /**
     * @return OK
     */
    getActiveTaskTypes2(signal?: AbortSignal): Promise<TaskTypePickerDTO2> {
        let url_ = this.baseUrl + "/TaskTypes/GetActiveTaskTypes2";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActiveTaskTypes2(_response);
        });
    }

    protected processGetActiveTaskTypes2(response: Response): Promise<TaskTypePickerDTO2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskTypePickerDTO2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskTypePickerDTO2>(null as any);
    }

    /**
     * @return OK
     */
    allTaskTypes2(signal?: AbortSignal): Promise<TaskTypePickerDTO2> {
        let url_ = this.baseUrl + "/TaskTypes/AllTaskTypes2";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAllTaskTypes2(_response);
        });
    }

    protected processAllTaskTypes2(response: Response): Promise<TaskTypePickerDTO2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskTypePickerDTO2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskTypePickerDTO2>(null as any);
    }

    /**
     * @return OK
     */
    internalTaskTypes(signal?: AbortSignal): Promise<TaskTypeBaseDTO[]> {
        let url_ = this.baseUrl + "/TaskTypes/InternalTaskTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInternalTaskTypes(_response);
        });
    }

    protected processInternalTaskTypes(response: Response): Promise<TaskTypeBaseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskTypeBaseDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskTypeBaseDTO[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateTaskType2(id: number | undefined, body: CreateAndUpdateTaskTypeDTO2 | undefined, signal?: AbortSignal): Promise<TaskTypeDetailedDTO2> {
        let url_ = this.baseUrl + "/TaskTypes/UpdateTaskType2?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTaskType2(_response);
        });
    }

    protected processUpdateTaskType2(response: Response): Promise<TaskTypeDetailedDTO2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskTypeDetailedDTO2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskTypeDetailedDTO2>(null as any);
    }

    /**
     * @return OK
     */
    allReasonCodes(signal?: AbortSignal): Promise<ReasonCodeDTO[]> {
        let url_ = this.baseUrl + "/TaskTypes/AllReasonCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAllReasonCodes(_response);
        });
    }

    protected processAllReasonCodes(response: Response): Promise<ReasonCodeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReasonCodeDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReasonCodeDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    reasonCodes2GET(id: number, signal?: AbortSignal): Promise<UpdateReasonCodeStatusDTO2[]> {
        let url_ = this.baseUrl + "/TaskTypes/{id}/ReasonCodes2";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReasonCodes2GET(_response);
        });
    }

    protected processReasonCodes2GET(response: Response): Promise<UpdateReasonCodeStatusDTO2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateReasonCodeStatusDTO2[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateReasonCodeStatusDTO2[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    reasonCodes2POST(id: number, body: UpdateReasonCodeStatusDTO2[] | undefined, signal?: AbortSignal): Promise<UpdateReasonCodeStatusDTO2[]> {
        let url_ = this.baseUrl + "/TaskTypes/{id}/ReasonCodes2";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReasonCodes2POST(_response);
        });
    }

    protected processReasonCodes2POST(response: Response): Promise<UpdateReasonCodeStatusDTO2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateReasonCodeStatusDTO2[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateReasonCodeStatusDTO2[]>(null as any);
    }

    /**
     * @param taskTypeId (optional) 
     * @return OK
     */
    getComponentsForTaskType(taskTypeId: number | undefined, signal?: AbortSignal): Promise<ComponentLabelDTO[]> {
        let url_ = this.baseUrl + "/TaskTypes/GetComponentsForTaskType?";
        if (taskTypeId === null)
            throw new Error("The parameter 'taskTypeId' cannot be null.");
        else if (taskTypeId !== undefined)
            url_ += "taskTypeId=" + encodeURIComponent("" + taskTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetComponentsForTaskType(_response);
        });
    }

    protected processGetComponentsForTaskType(response: Response): Promise<ComponentLabelDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComponentLabelDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComponentLabelDTO[]>(null as any);
    }

    /**
     * @param taskTypeId (optional) 
     * @param body (optional) 
     * @return OK
     */
    setComponentsForTaskType(taskTypeId: number | undefined, body: ComponentDTO[] | undefined, signal?: AbortSignal): Promise<ComponentLabelDTO[]> {
        let url_ = this.baseUrl + "/TaskTypes/SetComponentsForTaskType?";
        if (taskTypeId === null)
            throw new Error("The parameter 'taskTypeId' cannot be null.");
        else if (taskTypeId !== undefined)
            url_ += "taskTypeId=" + encodeURIComponent("" + taskTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetComponentsForTaskType(_response);
        });
    }

    protected processSetComponentsForTaskType(response: Response): Promise<ComponentLabelDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComponentLabelDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComponentLabelDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    getExternalResources(taskTypeId: number, signal?: AbortSignal): Promise<TaskTypeExternalResourceDTO[]> {
        let url_ = this.baseUrl + "/TaskTypes/{taskTypeId}/GetExternalResources";
        if (taskTypeId === undefined || taskTypeId === null)
            throw new Error("The parameter 'taskTypeId' must be defined.");
        url_ = url_.replace("{taskTypeId}", encodeURIComponent("" + taskTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExternalResources(_response);
        });
    }

    protected processGetExternalResources(response: Response): Promise<TaskTypeExternalResourceDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskTypeExternalResourceDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskTypeExternalResourceDTO[]>(null as any);
    }

    /**
     * @param taskTypeId (optional) 
     * @param body (optional) 
     * @return OK
     */
    setExternalResources(taskTypeId: number | undefined, body: TaskTypeExternalResourceDTO[] | undefined, signal?: AbortSignal): Promise<TaskTypeExternalResourceDTO[]> {
        let url_ = this.baseUrl + "/TaskTypes/SetExternalResources?";
        if (taskTypeId === null)
            throw new Error("The parameter 'taskTypeId' cannot be null.");
        else if (taskTypeId !== undefined)
            url_ += "taskTypeId=" + encodeURIComponent("" + taskTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetExternalResources(_response);
        });
    }

    protected processSetExternalResources(response: Response): Promise<TaskTypeExternalResourceDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskTypeExternalResourceDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskTypeExternalResourceDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    getAlarmTypes(signal?: AbortSignal): Promise<AlarmTypeDTO[]> {
        let url_ = this.baseUrl + "/TaskTypes/GetAlarmTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAlarmTypes(_response);
        });
    }

    protected processGetAlarmTypes(response: Response): Promise<AlarmTypeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AlarmTypeDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlarmTypeDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    techniciansAll(signal?: AbortSignal): Promise<TechnicianDTO[]> {
        let url_ = this.baseUrl + "/TechnicianDuty/technicians";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTechniciansAll(_response);
        });
    }

    protected processTechniciansAll(response: Response): Promise<TechnicianDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TechnicianDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TechnicianDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    technicians(body: TechnicianStatusDTO | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/TechnicianDuty/technicians";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTechnicians(_response);
        });
    }

    protected processTechnicians(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * If projectId is null, all employee categories are returned.
     * @param projectId (optional) 
     * @return OK
     */
    getCategoriesByProject(projectId: string | undefined, signal?: AbortSignal): Promise<CategoryDTO2[]> {
        let url_ = this.baseUrl + "/TimeRegistration/categoriesByProject?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCategoriesByProject(_response);
        });
    }

    protected processGetCategoriesByProject(response: Response): Promise<CategoryDTO2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CategoryDTO2[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryDTO2[]>(null as any);
    }

    /**
     * If projectId is null, all employee categories are returned.
     * @param projectId (optional) 
     * @return OK
     * @deprecated
     */
    getTimeCategoriesByProject(projectId: string | undefined, signal?: AbortSignal): Promise<CategoryDTO2[]> {
        let url_ = this.baseUrl + "/TimeRegistration/categories2?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTimeCategoriesByProject(_response);
        });
    }

    protected processGetTimeCategoriesByProject(response: Response): Promise<CategoryDTO2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CategoryDTO2[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryDTO2[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    timeRegistrationPOST(body: CreateTimeRegistrationDTO | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/TimeRegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTimeRegistrationPOST(_response);
        });
    }

    protected processTimeRegistrationPOST(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    timeRegistrationAll(startDate: string | undefined, endDate: string | undefined, signal?: AbortSignal): Promise<DetailedTimeRegistrationDTO[]> {
        let url_ = this.baseUrl + "/TimeRegistration?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTimeRegistrationAll(_response);
        });
    }

    protected processTimeRegistrationAll(response: Response): Promise<DetailedTimeRegistrationDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DetailedTimeRegistrationDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DetailedTimeRegistrationDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    internalTime2(body: CreateInternalTaskTimeRegistrationDTO2 | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/TimeRegistration/InternalTime2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInternalTime2(_response);
        });
    }

    protected processInternalTime2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    task(taskId: number, signal?: AbortSignal): Promise<TimeRegistrationDTO[]> {
        let url_ = this.baseUrl + "/TimeRegistration/task/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTask(_response);
        });
    }

    protected processTask(response: Response): Promise<TimeRegistrationDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TimeRegistrationDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeRegistrationDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    regretTimeRegistration(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/TimeRegistration/regretRegistration/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegretTimeRegistration(_response);
        });
    }

    protected processRegretTimeRegistration(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    timeRegistrationPUT(id: number, body: UpdateTimeRegistrationDTO | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/TimeRegistration/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTimeRegistrationPUT(_response);
        });
    }

    protected processTimeRegistrationPUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    approveHours(body: number[] | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/TimeRegistration/approveHours";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApproveHours(_response);
        });
    }

    protected processApproveHours(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    notApprovedRegistrations(signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/TimeRegistration/notApprovedRegistrations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNotApprovedRegistrations(_response);
        });
    }

    protected processNotApprovedRegistrations(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    employeeInfo2(signal?: AbortSignal): Promise<EmployeeInfoResultDTO> {
        let url_ = this.baseUrl + "/TimeRegistration/employeeInfo2";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEmployeeInfo2(_response);
        });
    }

    protected processEmployeeInfo2(response: Response): Promise<EmployeeInfoResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmployeeInfoResultDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeInfoResultDTO>(null as any);
    }

    /**
     * @param groupId (optional) 
     * @return OK
     */
    getEmployeeCategoriesAndProjectByGroup(groupId: string | undefined, signal?: AbortSignal): Promise<GroupCategoryProjectDTO> {
        let url_ = this.baseUrl + "/TimeRegistration/employeeCategoriesAndProjectByGroup?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmployeeCategoriesAndProjectByGroup(_response);
        });
    }

    protected processGetEmployeeCategoriesAndProjectByGroup(response: Response): Promise<GroupCategoryProjectDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GroupCategoryProjectDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupCategoryProjectDTO>(null as any);
    }

    /**
     * @param workTaskId (optional) 
     * @return OK
     * @deprecated
     */
    checkIfWorkTaskHasTimeRegistrations(workTaskId: number | undefined, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/TimeRegistration/CheckIfWorkTaskHasTimeRegistrations?";
        if (workTaskId === null)
            throw new Error("The parameter 'workTaskId' cannot be null.");
        else if (workTaskId !== undefined)
            url_ += "workTaskId=" + encodeURIComponent("" + workTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckIfWorkTaskHasTimeRegistrations(_response);
        });
    }

    protected processCheckIfWorkTaskHasTimeRegistrations(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param workTaskId (optional) 
     * @return OK
     * @deprecated
     */
    moveTimeRegistrationsToWorkInvoiceProject(workTaskId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/TimeRegistration/MoveTimeRegistrationsToWorkInvoiceProject?";
        if (workTaskId === null)
            throw new Error("The parameter 'workTaskId' cannot be null.");
        else if (workTaskId !== undefined)
            url_ += "workTaskId=" + encodeURIComponent("" + workTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMoveTimeRegistrationsToWorkInvoiceProject(_response);
        });
    }

    protected processMoveTimeRegistrationsToWorkInvoiceProject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get (multiple) column configuration(s) for user. TagId -1 equals 'Driftsliste'. TagId -2 equals 'Alle opgaver'.
     * @return OK
     */
    getTaskListColumnConfigurations(signal?: AbortSignal): Promise<TaskListConfigurationDTO2[]> {
        let url_ = this.baseUrl + "/User/taskListColumnConfigurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTaskListColumnConfigurations(_response);
        });
    }

    protected processGetTaskListColumnConfigurations(response: Response): Promise<TaskListConfigurationDTO2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskListConfigurationDTO2[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskListConfigurationDTO2[]>(null as any);
    }

    /**
     * Save task list column configurations for user. TagId -1 equals 'Driftsliste'. TagId -2 equals 'Alle opgaver'.
     * @param body (optional) 
     * @return OK
     */
    saveTaskListColumnConfigurations(body: TaskListConfigurationDTO2 | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/User/taskListColumnConfigurations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveTaskListColumnConfigurations(_response);
        });
    }

    protected processSaveTaskListColumnConfigurations(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    filter3(body: TaskListCustomFilterDTO2 | undefined, signal?: AbortSignal): Promise<TaskListCustomFilterDTO> {
        let url_ = this.baseUrl + "/User/filter3";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFilter3(_response);
        });
    }

    protected processFilter3(response: Response): Promise<TaskListCustomFilterDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskListCustomFilterDTO;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskListCustomFilterDTO>(null as any);
    }

    /**
     * @param departmentId (optional) 
     * @param body (optional) 
     * @return OK
     */
    departmentFilter2(departmentId: number | undefined, body: TaskListCustomFilterDTO2 | undefined, signal?: AbortSignal): Promise<TaskListCustomFilterDTO> {
        let url_ = this.baseUrl + "/User/departmentFilter2?";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDepartmentFilter2(_response);
        });
    }

    protected processDepartmentFilter2(response: Response): Promise<TaskListCustomFilterDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskListCustomFilterDTO;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskListCustomFilterDTO>(null as any);
    }

    /**
     * Get all custom filters
     * @return OK
     */
    getTaskListFilters2(signal?: AbortSignal): Promise<TaskListCustomFilterDTO2[]> {
        let url_ = this.baseUrl + "/User/filters2";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTaskListFilters2(_response);
        });
    }

    protected processGetTaskListFilters2(response: Response): Promise<TaskListCustomFilterDTO2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskListCustomFilterDTO2[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskListCustomFilterDTO2[]>(null as any);
    }

    /**
     * Update a custom user filter for the task list
     * @param body (optional) 
     * @return OK
     */
    updateTaskListCustomUserFilter(body: TaskListCustomFilterDTO | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/User/UpdateTaskListCustomUserFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTaskListCustomUserFilter(_response);
        });
    }

    protected processUpdateTaskListCustomUserFilter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update a custom department filter for the task list
     * @param departmentId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateTaskListCustomDepartmentFilter(departmentId: number | undefined, body: TaskListCustomFilterDTO | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/User/UpdateTaskListCustomDepartmentFilter?";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTaskListCustomDepartmentFilter(_response);
        });
    }

    protected processUpdateTaskListCustomDepartmentFilter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param filterName (optional) 
     * @return OK
     */
    filter(filterName: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/User/filter?";
        if (filterName === null)
            throw new Error("The parameter 'filterName' cannot be null.");
        else if (filterName !== undefined)
            url_ += "filterName=" + encodeURIComponent("" + filterName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFilter(_response);
        });
    }

    protected processFilter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param filterName (optional) 
     * @param departmentId (optional) 
     * @return OK
     */
    taskListDepartmentFilter(filterName: string | undefined, departmentId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/User/TaskListDepartmentFilter?";
        if (filterName === null)
            throw new Error("The parameter 'filterName' cannot be null.");
        else if (filterName !== undefined)
            url_ += "filterName=" + encodeURIComponent("" + filterName) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTaskListDepartmentFilter(_response);
        });
    }

    protected processTaskListDepartmentFilter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param filterName (optional) 
     * @param departmentId (optional) 
     * @return OK
     */
    setSelectedFilter(filterName: string | undefined, departmentId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/User/setSelectedFilter?";
        if (filterName === null)
            throw new Error("The parameter 'filterName' cannot be null.");
        else if (filterName !== undefined)
            url_ += "filterName=" + encodeURIComponent("" + filterName) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetSelectedFilter(_response);
        });
    }

    protected processSetSelectedFilter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param filterName (optional) 
     * @param departmentId (optional) 
     * @return OK
     */
    setSelectedAllTasksFilter(filterName: string | undefined, departmentId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/User/setSelectedAllTasksFilter?";
        if (filterName === null)
            throw new Error("The parameter 'filterName' cannot be null.");
        else if (filterName !== undefined)
            url_ += "filterName=" + encodeURIComponent("" + filterName) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetSelectedAllTasksFilter(_response);
        });
    }

    protected processSetSelectedAllTasksFilter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getUsersAllKnown(signal?: AbortSignal): Promise<UserDTO[]> {
        let url_ = this.baseUrl + "/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsersAllKnown(_response);
        });
    }

    protected processGetUsersAllKnown(response: Response): Promise<UserDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    logUserLoggedIn(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/User/log";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogUserLoggedIn(_response);
        });
    }

    protected processLogUserLoggedIn(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param email (optional) 
     * @return OK
     */
    getProfileByEmail(email: string | undefined, signal?: AbortSignal): Promise<ProfileDTO> {
        let url_ = this.baseUrl + "/User/profileByEmail?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProfileByEmail(_response);
        });
    }

    protected processGetProfileByEmail(response: Response): Promise<ProfileDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileDTO>(null as any);
    }

    /**
     * @return OK
     */
    getProfile(signal?: AbortSignal): Promise<ProfileDTO> {
        let url_ = this.baseUrl + "/User/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProfile(_response);
        });
    }

    protected processGetProfile(response: Response): Promise<ProfileDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateUserProfile(body: UpdateProfileDTO2 | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/User/profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUserProfile(_response);
        });
    }

    protected processUpdateUserProfile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     * @deprecated
     */
    getProfile3(signal?: AbortSignal): Promise<ProfileDTO2> {
        let url_ = this.baseUrl + "/User/profile3";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProfile3(_response);
        });
    }

    protected processGetProfile3(response: Response): Promise<ProfileDTO2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileDTO2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileDTO2>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveUserProfile(body: SaveProfileDTO2 | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/User/saveProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveUserProfile(_response);
        });
    }

    protected processSaveUserProfile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    updateProfile(body: UpdateProfileDTO2 | undefined, signal?: AbortSignal): Promise<ProfileDTO2> {
        let url_ = this.baseUrl + "/User/Profile2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProfile(_response);
        });
    }

    protected processUpdateProfile(response: Response): Promise<ProfileDTO2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileDTO2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileDTO2>(null as any);
    }

    /**
     * @param role (optional) 
     * @return OK
     */
    changeRole(role: Role | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/User/ChangeRole?";
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeRole(_response);
        });
    }

    protected processChangeRole(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param workTaskId (optional) 
     * @return OK
     */
    getConsumedItems(workTaskId: number | undefined, signal?: AbortSignal): Promise<ItemConsumptionDTO[]> {
        let url_ = this.baseUrl + "/Warehouse/GetConsumedItems?";
        if (workTaskId === null)
            throw new Error("The parameter 'workTaskId' cannot be null.");
        else if (workTaskId !== undefined)
            url_ += "workTaskId=" + encodeURIComponent("" + workTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConsumedItems(_response);
        });
    }

    protected processGetConsumedItems(response: Response): Promise<ItemConsumptionDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ItemConsumptionDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ItemConsumptionDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    consumeItems(body: CreateItemConsumptionDTO | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Warehouse/ConsumeItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConsumeItems(_response);
        });
    }

    protected processConsumeItems(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param legalEntityId (optional) 
     * @param warehouseId (optional) 
     * @param locationId (optional) 
     * @param itemId (optional) 
     * @param includePictureLinks (optional) 
     * @return OK
     */
    getItemsOnHand3(legalEntityId: string | undefined, warehouseId: string | undefined, locationId: string | undefined, itemId: string | undefined, includePictureLinks: boolean | undefined, signal?: AbortSignal): Promise<StockDTO[]> {
        let url_ = this.baseUrl + "/Warehouse/GetItemsOnHand3?";
        if (legalEntityId === null)
            throw new Error("The parameter 'legalEntityId' cannot be null.");
        else if (legalEntityId !== undefined)
            url_ += "legalEntityId=" + encodeURIComponent("" + legalEntityId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        if (includePictureLinks === null)
            throw new Error("The parameter 'includePictureLinks' cannot be null.");
        else if (includePictureLinks !== undefined)
            url_ += "includePictureLinks=" + encodeURIComponent("" + includePictureLinks) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetItemsOnHand3(_response);
        });
    }

    protected processGetItemsOnHand3(response: Response): Promise<StockDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StockDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StockDTO[]>(null as any);
    }

    /**
     * @param region (optional) 
     * @return OK
     */
    getWarehouses(region: Region2 | undefined, signal?: AbortSignal): Promise<WarehouseDTO[]> {
        let url_ = this.baseUrl + "/Warehouse/GetWarehouses?";
        if (region === null)
            throw new Error("The parameter 'region' cannot be null.");
        else if (region !== undefined)
            url_ += "region=" + encodeURIComponent("" + region) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWarehouses(_response);
        });
    }

    protected processGetWarehouses(response: Response): Promise<WarehouseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WarehouseDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarehouseDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    getOrdersWarehouses(signal?: AbortSignal): Promise<WarehouseDTO[]> {
        let url_ = this.baseUrl + "/Warehouse/GetOrdersWarehouses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrdersWarehouses(_response);
        });
    }

    protected processGetOrdersWarehouses(response: Response): Promise<WarehouseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WarehouseDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarehouseDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    getEmergencyWarehouses(signal?: AbortSignal): Promise<WarehouseDTO[]> {
        let url_ = this.baseUrl + "/Warehouse/GetEmergencyWarehouses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmergencyWarehouses(_response);
        });
    }

    protected processGetEmergencyWarehouses(response: Response): Promise<WarehouseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WarehouseDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarehouseDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    getJournalWarehouses(signal?: AbortSignal): Promise<WarehouseExtendedDTO[]> {
        let url_ = this.baseUrl + "/Warehouse/GetJournalWarehouses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJournalWarehouses(_response);
        });
    }

    protected processGetJournalWarehouses(response: Response): Promise<WarehouseExtendedDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WarehouseExtendedDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarehouseExtendedDTO[]>(null as any);
    }

    /**
     * @param legalEntityId (optional) 
     * @param warehouseId (optional) 
     * @param locationId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateWarehouseStock(legalEntityId: string | undefined, warehouseId: string | undefined, locationId: string | undefined, body: UpdateStockDTO[] | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Warehouse/UpdateWarehouseStock?";
        if (legalEntityId === null)
            throw new Error("The parameter 'legalEntityId' cannot be null.");
        else if (legalEntityId !== undefined)
            url_ += "legalEntityId=" + encodeURIComponent("" + legalEntityId) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateWarehouseStock(_response);
        });
    }

    protected processUpdateWarehouseStock(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @return OK
     */
    getAllowedDeliveryDates(warehouseId: string | undefined, signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/Warehouse/GetAllowedDeliveryDates?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllowedDeliveryDates(_response);
        });
    }

    protected processGetAllowedDeliveryDates(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param workTaskId (optional) 
     * @return OK
     */
    getActiveOrdersByWorkTask(workTaskId: number | undefined, signal?: AbortSignal): Promise<OrderDTO[]> {
        let url_ = this.baseUrl + "/Warehouse/activeOrdersByWorkTask?";
        if (workTaskId === null)
            throw new Error("The parameter 'workTaskId' cannot be null.");
        else if (workTaskId !== undefined)
            url_ += "workTaskId=" + encodeURIComponent("" + workTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActiveOrdersByWorkTask(_response);
        });
    }

    protected processGetActiveOrdersByWorkTask(response: Response): Promise<OrderDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrderDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderDTO[]>(null as any);
    }

    /**
     * @param workTaskId (optional) 
     * @return OK
     */
    getActiveOrdersByWorkTaskAndUser(workTaskId: number | undefined, signal?: AbortSignal): Promise<OrderDTO[]> {
        let url_ = this.baseUrl + "/Warehouse/activeOrdersByWorkTaskAndUser?";
        if (workTaskId === null)
            throw new Error("The parameter 'workTaskId' cannot be null.");
        else if (workTaskId !== undefined)
            url_ += "workTaskId=" + encodeURIComponent("" + workTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActiveOrdersByWorkTaskAndUser(_response);
        });
    }

    protected processGetActiveOrdersByWorkTaskAndUser(response: Response): Promise<OrderDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrderDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    getAllDeliveryDropPoints(signal?: AbortSignal): Promise<DropPointDTO[]> {
        let url_ = this.baseUrl + "/Warehouse/GetAllDeliveryDropPoints";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllDeliveryDropPoints(_response);
        });
    }

    protected processGetAllDeliveryDropPoints(response: Response): Promise<DropPointDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DropPointDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DropPointDTO[]>(null as any);
    }

    /**
     * @param latitude (optional) 
     * @param longitude (optional) 
     * @return OK
     */
    getDropPointsByDistance(latitude: number | undefined, longitude: number | undefined, signal?: AbortSignal): Promise<DropPointDTO[]> {
        let url_ = this.baseUrl + "/Warehouse/GetDropPointsByDistance?";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDropPointsByDistance(_response);
        });
    }

    protected processGetDropPointsByDistance(response: Response): Promise<DropPointDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DropPointDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DropPointDTO[]>(null as any);
    }

    /**
     * Returns the stock of a list of items on the main warehouse.
     * @param body (optional) 
     * @return OK
     */
    getStockForItems(body: string[] | undefined, signal?: AbortSignal): Promise<StockDTO[]> {
        let url_ = this.baseUrl + "/Warehouse/GetStockForItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStockForItems(_response);
        });
    }

    protected processGetStockForItems(response: Response): Promise<StockDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StockDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StockDTO[]>(null as any);
    }

    /**
     * @param workTaskId (optional) 
     * @return OK
     */
    checkIfWorkTaskHasConsumedItemsOrTimeRegistrations(workTaskId: number | undefined, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/Warehouse/CheckIfWorkTaskHasConsumedItemsOrTimeRegistrations?";
        if (workTaskId === null)
            throw new Error("The parameter 'workTaskId' cannot be null.");
        else if (workTaskId !== undefined)
            url_ += "workTaskId=" + encodeURIComponent("" + workTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckIfWorkTaskHasConsumedItemsOrTimeRegistrations(_response);
        });
    }

    protected processCheckIfWorkTaskHasConsumedItemsOrTimeRegistrations(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getMainWarehouseInventoryByItems(body: string[] | undefined, signal?: AbortSignal): Promise<StockDTO[]> {
        let url_ = this.baseUrl + "/Warehouse/GetMainWarehouseInventoryByItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMainWarehouseInventoryByItems(_response);
        });
    }

    protected processGetMainWarehouseInventoryByItems(response: Response): Promise<StockDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StockDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StockDTO[]>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    canOrderGoods(projectId: string | undefined, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/Warehouse/CanOrderGoods?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCanOrderGoods(_response);
        });
    }

    protected processCanOrderGoods(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    canConsumeGoods(projectId: string | undefined, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/Warehouse/CanConsumeGoods?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCanConsumeGoods(_response);
        });
    }

    protected processCanConsumeGoods(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    workInvoice(workInvoiceId: number, signal?: AbortSignal): Promise<WorkInvoiceResponseDTO> {
        let url_ = this.baseUrl + "/WorkInvoice/{workInvoiceId}";
        if (workInvoiceId === undefined || workInvoiceId === null)
            throw new Error("The parameter 'workInvoiceId' must be defined.");
        url_ = url_.replace("{workInvoiceId}", encodeURIComponent("" + workInvoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWorkInvoice(_response);
        });
    }

    protected processWorkInvoice(response: Response): Promise<WorkInvoiceResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkInvoiceResponseDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkInvoiceResponseDTO>(null as any);
    }

    /**
     * @return OK
     */
    getWorkInvoiceId(baseWorkTaskId: number, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/WorkInvoice/GetWorkInvoiceId/{baseWorkTaskId}";
        if (baseWorkTaskId === undefined || baseWorkTaskId === null)
            throw new Error("The parameter 'baseWorkTaskId' must be defined.");
        url_ = url_.replace("{baseWorkTaskId}", encodeURIComponent("" + baseWorkTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWorkInvoiceId(_response);
        });
    }

    protected processGetWorkInvoiceId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    getProjectNumber(workInvoiceId: number, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/WorkInvoice/{workInvoiceId}/GetProjectNumber";
        if (workInvoiceId === undefined || workInvoiceId === null)
            throw new Error("The parameter 'workInvoiceId' must be defined.");
        url_ = url_.replace("{workInvoiceId}", encodeURIComponent("" + workInvoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProjectNumber(_response);
        });
    }

    protected processGetProjectNumber(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    associateWorkInvoice(taskId: number, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/WorkInvoice/Associate/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssociateWorkInvoice(_response);
        });
    }

    protected processAssociateWorkInvoice(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateWorkInvoice(workInvoiceId: number, body: UpdateWorkInvoiceDTO | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/WorkInvoice/{workInvoiceId}/UpdateWorkInvoice";
        if (workInvoiceId === undefined || workInvoiceId === null)
            throw new Error("The parameter 'workInvoiceId' must be defined.");
        url_ = url_.replace("{workInvoiceId}", encodeURIComponent("" + workInvoiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateWorkInvoice(_response);
        });
    }

    protected processUpdateWorkInvoice(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateUnknownDebtor(workInvoiceId: number, body: boolean | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/WorkInvoice/{workInvoiceId}/UpdateUnknownDebtor";
        if (workInvoiceId === undefined || workInvoiceId === null)
            throw new Error("The parameter 'workInvoiceId' must be defined.");
        url_ = url_.replace("{workInvoiceId}", encodeURIComponent("" + workInvoiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUnknownDebtor(_response);
        });
    }

    protected processUpdateUnknownDebtor(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateProjectCategory(workInvoiceId: number, body: WorkInvoiceProjectCategory | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/WorkInvoice/{workInvoiceId}/UpdateProjectCategory";
        if (workInvoiceId === undefined || workInvoiceId === null)
            throw new Error("The parameter 'workInvoiceId' must be defined.");
        url_ = url_.replace("{workInvoiceId}", encodeURIComponent("" + workInvoiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProjectCategory(_response);
        });
    }

    protected processUpdateProjectCategory(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param baseWorkTaskId (optional) 
     * @return OK
     */
    delete(workInvoiceId: number, baseWorkTaskId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/WorkInvoice/{workInvoiceId}/Delete?";
        if (workInvoiceId === undefined || workInvoiceId === null)
            throw new Error("The parameter 'workInvoiceId' must be defined.");
        url_ = url_.replace("{workInvoiceId}", encodeURIComponent("" + workInvoiceId));
        if (baseWorkTaskId === null)
            throw new Error("The parameter 'baseWorkTaskId' cannot be null.");
        else if (baseWorkTaskId !== undefined)
            url_ += "baseWorkTaskId=" + encodeURIComponent("" + baseWorkTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    hasHoursToMove(workInvoiceId: number, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/WorkInvoice/{workInvoiceId}/HasHoursToMove";
        if (workInvoiceId === undefined || workInvoiceId === null)
            throw new Error("The parameter 'workInvoiceId' must be defined.");
        url_ = url_.replace("{workInvoiceId}", encodeURIComponent("" + workInvoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHasHoursToMove(_response);
        });
    }

    protected processHasHoursToMove(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    moveHoursToWorkInvoiceProject(workInvoiceId: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/WorkInvoice/{workInvoiceId}/MoveHoursToWorkInvoiceProject";
        if (workInvoiceId === undefined || workInvoiceId === null)
            throw new Error("The parameter 'workInvoiceId' must be defined.");
        url_ = url_.replace("{workInvoiceId}", encodeURIComponent("" + workInvoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMoveHoursToWorkInvoiceProject(_response);
        });
    }

    protected processMoveHoursToWorkInvoiceProject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    hasConsumedItemsToMove(workInvoiceId: number, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/WorkInvoice/{workInvoiceId}/HasConsumedItemsToMove";
        if (workInvoiceId === undefined || workInvoiceId === null)
            throw new Error("The parameter 'workInvoiceId' must be defined.");
        url_ = url_.replace("{workInvoiceId}", encodeURIComponent("" + workInvoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHasConsumedItemsToMove(_response);
        });
    }

    protected processHasConsumedItemsToMove(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    moveItemsToWorkInvoiceProject(workInvoiceId: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/WorkInvoice/{workInvoiceId}/MoveItemsToWorkInvoiceProject";
        if (workInvoiceId === undefined || workInvoiceId === null)
            throw new Error("The parameter 'workInvoiceId' must be defined.");
        url_ = url_.replace("{workInvoiceId}", encodeURIComponent("" + workInvoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMoveItemsToWorkInvoiceProject(_response);
        });
    }

    protected processMoveItemsToWorkInvoiceProject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param workTaskId (optional) 
     * @return OK
     */
    validateChecklistsAsync2(workTaskId: number | undefined, signal?: AbortSignal): Promise<InvalidChecklistDTO2[]> {
        let url_ = this.baseUrl + "/WorktaskChecklists/validateChecklists2?";
        if (workTaskId === null)
            throw new Error("The parameter 'workTaskId' cannot be null.");
        else if (workTaskId !== undefined)
            url_ += "workTaskId=" + encodeURIComponent("" + workTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidateChecklistsAsync2(_response);
        });
    }

    protected processValidateChecklistsAsync2(response: Response): Promise<InvalidChecklistDTO2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InvalidChecklistDTO2[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvalidChecklistDTO2[]>(null as any);
    }

    /**
     * @param workTaskCheckListId (optional) 
     * @return OK
     */
    validateChecklistAsync2(workTaskCheckListId: number | undefined, signal?: AbortSignal): Promise<InvalidChecklistDTO2> {
        let url_ = this.baseUrl + "/WorktaskChecklists/validateChecklist2?";
        if (workTaskCheckListId === null)
            throw new Error("The parameter 'workTaskCheckListId' cannot be null.");
        else if (workTaskCheckListId !== undefined)
            url_ += "workTaskCheckListId=" + encodeURIComponent("" + workTaskCheckListId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidateChecklistAsync2(_response);
        });
    }

    protected processValidateChecklistAsync2(response: Response): Promise<InvalidChecklistDTO2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InvalidChecklistDTO2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvalidChecklistDTO2>(null as any);
    }

    /**
     * @param workTaskId (optional) 
     * @param taskTypeChecklistId (optional) 
     * @return OK
     */
    createRepeatableChecklist(workTaskId: number | undefined, taskTypeChecklistId: number | undefined, signal?: AbortSignal): Promise<ChecklistDTO> {
        let url_ = this.baseUrl + "/WorktaskChecklists/CreateRepeatableChecklist?";
        if (workTaskId === null)
            throw new Error("The parameter 'workTaskId' cannot be null.");
        else if (workTaskId !== undefined)
            url_ += "workTaskId=" + encodeURIComponent("" + workTaskId) + "&";
        if (taskTypeChecklistId === null)
            throw new Error("The parameter 'taskTypeChecklistId' cannot be null.");
        else if (taskTypeChecklistId !== undefined)
            url_ += "taskTypeChecklistId=" + encodeURIComponent("" + taskTypeChecklistId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRepeatableChecklist(_response);
        });
    }

    protected processCreateRepeatableChecklist(response: Response): Promise<ChecklistDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChecklistDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChecklistDTO>(null as any);
    }

    /**
     * @param workTaskChecklistSectionId (optional) 
     * @return OK
     */
    deleteRepeatableChecklist(workTaskChecklistSectionId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/WorktaskChecklists/DeleteRepeatableChecklist?";
        if (workTaskChecklistSectionId === null)
            throw new Error("The parameter 'workTaskChecklistSectionId' cannot be null.");
        else if (workTaskChecklistSectionId !== undefined)
            url_ += "workTaskChecklistSectionId=" + encodeURIComponent("" + workTaskChecklistSectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRepeatableChecklist(_response);
        });
    }

    protected processDeleteRepeatableChecklist(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param sectionId (optional) 
     * @param workTaskChecklistId (optional) 
     * @return OK
     */
    createRepeatableSectionForChecklist(workTaskId: number, sectionId: number | undefined, workTaskChecklistId: number | undefined, signal?: AbortSignal): Promise<SectionDTO> {
        let url_ = this.baseUrl + "/WorktaskChecklists/{workTaskId}/CreateRepeatableSectionForChecklist?";
        if (workTaskId === undefined || workTaskId === null)
            throw new Error("The parameter 'workTaskId' must be defined.");
        url_ = url_.replace("{workTaskId}", encodeURIComponent("" + workTaskId));
        if (sectionId === null)
            throw new Error("The parameter 'sectionId' cannot be null.");
        else if (sectionId !== undefined)
            url_ += "sectionId=" + encodeURIComponent("" + sectionId) + "&";
        if (workTaskChecklistId === null)
            throw new Error("The parameter 'workTaskChecklistId' cannot be null.");
        else if (workTaskChecklistId !== undefined)
            url_ += "workTaskChecklistId=" + encodeURIComponent("" + workTaskChecklistId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRepeatableSectionForChecklist(_response);
        });
    }

    protected processCreateRepeatableSectionForChecklist(response: Response): Promise<SectionDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SectionDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SectionDTO>(null as any);
    }

    /**
     * @return OK
     */
    checklists3(workTaskId: number, signal?: AbortSignal): Promise<ChecklistsDTO> {
        let url_ = this.baseUrl + "/WorktaskChecklists/{workTaskId}/checklists3";
        if (workTaskId === undefined || workTaskId === null)
            throw new Error("The parameter 'workTaskId' must be defined.");
        url_ = url_.replace("{workTaskId}", encodeURIComponent("" + workTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChecklists3(_response);
        });
    }

    protected processChecklists3(response: Response): Promise<ChecklistsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChecklistsDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChecklistsDTO>(null as any);
    }

    /**
     * @param workTaskId (optional) 
     * @return OK
     */
    createChecklists2(workTaskId: number | undefined, signal?: AbortSignal): Promise<ChecklistsDTO> {
        let url_ = this.baseUrl + "/WorktaskChecklists/CreateChecklists2?";
        if (workTaskId === null)
            throw new Error("The parameter 'workTaskId' cannot be null.");
        else if (workTaskId !== undefined)
            url_ += "workTaskId=" + encodeURIComponent("" + workTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateChecklists2(_response);
        });
    }

    protected processCreateChecklists2(response: Response): Promise<ChecklistsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChecklistsDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChecklistsDTO>(null as any);
    }

    /**
     * @param status (optional) 
     * @param body (optional) 
     * @return OK
     */
    setChecklistCompletionStatus(status: boolean | undefined, body: number[] | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/WorktaskChecklists/SetChecklistCompletionStatus?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetChecklistCompletionStatus(_response);
        });
    }

    protected processSetChecklistCompletionStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param status (optional) 
     * @param body (optional) 
     * @return OK
     */
    setTaskSectionCompletionStatus(status: boolean | undefined, body: number[] | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/WorktaskChecklists/SetTaskSectionCompletionStatus?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetTaskSectionCompletionStatus(_response);
        });
    }

    protected processSetTaskSectionCompletionStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Health check response
     */
    healthz(signal?: AbortSignal): Promise<Anonymous> {
        let url_ = this.baseUrl + "/healthz";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHealthz(_response);
        });
    }

    protected processHealthz(response: Response): Promise<Anonymous> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Anonymous>(null as any);
    }
}

export interface AccessConditionsDTO {
    keyBoxInfo?: string | undefined;
    accessInfo?: string | undefined;
    technicianApproval?: string | undefined;
    objectId?: number | undefined;
}

export interface AddAccessConditionsDTO {
    keyBoxInfo?: string | undefined;
    accessInfo?: string | undefined;
    assetId?: string | undefined;
    x?: number;
    y?: number;
}

export enum AssetType {
    Netstation = "Netstation",
    CabelBox = "CabelBox",
    InstallationNumber = "InstallationNumber",
    HighVoltageNetstation = "HighVoltageNetstation",
    Meter = "Meter",
    Stretch = "Stretch",
}

export interface ComponentCommentRequestDTO {
    workTaskId?: number;
    componentObjectId?: string | undefined;
    value?: string | undefined;
}

export interface ComponentCommentResponseDTO {
    id?: number;
    workTaskId?: number;
    componentObjectId?: string | undefined;
    value?: string | undefined;
    createdDateTime?: string;
    createdByEmail?: string | undefined;
    createdByName?: string | undefined;
}

export interface ComponentDetailResponseDTO {
    objectId?: number;
    properties?: ComponentPropertyDTO[] | undefined;
}

export interface ComponentFieldChangeDTO {
    workTaskId?: number;
    componentObjectId?: string | undefined;
    fieldName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    componentType?: StationComponentEnum;
    createdDateTime?: string;
}

export interface ComponentFileUploadRequestDTO {
    fileName?: string | undefined;
    componentId?: string | undefined;
    workTaskId?: number;
    assetId?: string | undefined;
}

export interface ComponentFileUploadResponseDTO {
    id?: number;
    fileName?: string | undefined;
    uploadedTime?: string | undefined;
    uploadedByEmail?: string | undefined;
    uploadedByName?: string | undefined;
    componentId?: string | undefined;
    workTaskId?: number;
    assetId?: string | undefined;
}

export interface ComponentPropertyDTO {
    name?: string | undefined;
    value?: string | undefined;
}

export interface CoordinateDTO {
    yCoord?: number;
    xCoord?: number;
    yCoord_FLS?: string | undefined;
    xCoord_FLS?: string | undefined;
}

export interface GisChangeInfoDTO {
    listViewComments?: ListViewCommentResponseDTO[] | undefined;
    componentComments?: ComponentCommentResponseDTO[] | undefined;
    componentFieldChanges?: ComponentFieldChangeDTO[] | undefined;
    listViewFileUploads?: ListViewFileUploadResponseDTO[] | undefined;
    componentFileUploads?: ComponentFileUploadResponseDTO[] | undefined;
}

export enum GisRegion {
    North = "North",
    South = "South",
}

export interface ListViewCommentRequestDTO {
    workTaskId?: number;
    value?: string | undefined;
}

export interface ListViewCommentResponseDTO {
    id?: number;
    workTaskId?: number;
    value?: string | undefined;
    createdDateTime?: string;
    createdByEmail?: string | undefined;
    createdByName?: string | undefined;
}

export interface ListViewFileUploadRequestDTO {
    fileName?: string | undefined;
    assetId?: string | undefined;
    workTaskId?: number;
}

export interface ListViewFileUploadResponseDTO {
    id?: number;
    fileName?: string | undefined;
    uploadedTime?: string | undefined;
    uploadedByEmail?: string | undefined;
    uploadedByName?: string | undefined;
    assetId?: string | undefined;
    workTaskId?: number;
}

export interface MassLookupAssetDTO {
    assetId?: string | undefined;
    exist?: boolean;
    primaerSpaendingsNiveauKode?: number | undefined;
    coordinates?: CoordinateDTO;
}

export interface MassLookupDTO {
    region?: Region;
    assetType?: AssetType;
    assetIds?: string[] | undefined;
}

export interface MassLookupResponseDTO {
    assets?: MassLookupAssetDTO[] | undefined;
}

export interface NetstationComponentsResponseDTO {
    mediumVoltageComponents?: StationComponentDTO[] | undefined;
    transformerComponents?: StationComponentDTO[] | undefined;
    lowVoltageComponents?: StationComponentDTO[] | undefined;
}

export enum Region {
    North = "North",
    South = "South",
    OneERP = "OneERP",
}

export interface StationComponentDTO {
    objectId?: number;
    name?: string | undefined;
    componentType?: StationComponentEnum;
    voltage?: number | undefined;
    "driftsmærkning"?: string | undefined;
    subComponents?: StationComponentDTO[] | undefined;
}

export enum StationComponentEnum {
    Kabelmuffe = "Kabelmuffe",
    SikringLV = "SikringLV",
    Samleskinne = "Samleskinne",
    Kortslutningsindikator = "Kortslutningsindikator",
    Effektbryder = "Effektbryder",
    Lastbryder = "Lastbryder",
    Adskiller = "Adskiller",
    Laske = "Laske",
    Fordelingstransformer = "Fordelingstransformer",
    Spændingstransformer = "Spændingstransformer",
    Strømtransformer = "Strømtransformer",
    Overstrømsrelæ = "Overstrømsrelæ",
    Kondensatorbatteri = "Kondensatorbatteri",
    Adgangsforhold = "Adgangsforhold",
    SikringMV = "SikringMV",
    Forbindelseskabel = "Forbindelseskabel",
}

export enum Status {
    OnCall = "OnCall",
    ShiftEnded = "ShiftEnded",
    Rest = "Rest",
    Absent = "Absent",
    OnCallApprentice = "OnCallApprentice",
}

export interface TechnicianDTO {
    name?: string | undefined;
    initials?: string | undefined;
    currentArcGisStatus?: string | undefined;
    objectId?: number;
}

export interface TechnicianStatusDTO {
    initials: string;
    objectId?: number;
    statusCode: Status;
}

export interface UpdateAccessConditionsDTO {
    keyBoxInfo?: string | undefined;
    accessInfo?: string | undefined;
    objectId?: number;
}

export interface AccessInformation {
    contactPerson?: string | undefined;
    doorCode?: string | undefined;
    doorCodeComment?: string | undefined;
    keyComment?: string | undefined;
    keyNumber?: string | undefined;
    keyPlacement?: string | undefined;
    keyStorageLocation?: string | undefined;
    type?: string | undefined;
}

export interface Address {
    cityName?: string | undefined;
    countryCode?: string | undefined;
    darId?: string | undefined;
    houseNumber?: string | undefined;
    door?: string | undefined;
    floor?: string | undefined;
    postalCode?: number | undefined;
    streetName?: string | undefined;
    coordinate?: GeoCoordinate;
}

export interface AddressDto {
    streetName?: string | undefined;
    houseNumber?: string | undefined;
    door?: string | undefined;
    floor?: string | undefined;
    postalCode?: number;
    cityName?: string | undefined;
}

export interface ContactInfo {
    contactType?: ContactPersonTypeEnum;
    details?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    companyName?: string | undefined;
    phoneNumber?: string | undefined;
    address?: Address;
}

export interface ContactInfoDto {
    contactType?: ContactPersonTypeEnum;
    name?: string | undefined;
    address?: AddressDto;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    companyName?: string | undefined;
    otherInformation?: string | undefined;
}

export enum ContactPersonTypeEnum {
    Installer = "Installer",
    PrimaryContact = "PrimaryContact",
    AlternativeContact = "AlternativeContact",
    ProjectManager = "ProjectManager",
    TechnicalContact = "TechnicalContact",
}

export interface GeoCoordinate {
    latitude?: number;
    longitude?: number;
}

export interface PlanningInfo {
    assignedTechnicianEmail?: string | undefined;
    assignedTechnicianName?: string | undefined;
    taskStart?: string | undefined;
    taskEnd?: string | undefined;
    plannedArrival?: string | undefined;
    plannedDuration?: number | undefined;
}

export interface WorkOrderInfo {
    workOrderId: string;
    workOrderNumber?: string | undefined;
    smileWorkOrderId?: string | undefined;
    workDescriptionTypeCode?: string | undefined;
    billable?: boolean | undefined;
    projectNumber?: string | undefined;
    description?: string | undefined;
    connectionPointId?: string | undefined;
    meterId?: string | undefined;
    meterFrameId?: string | undefined;
    meterPlacement?: string | undefined;
    address?: Address;
    accessInformation?: AccessInformation;
    contacts?: ContactInfo[] | undefined;
    planningInfo?: PlanningInfo;
    installationDescription?: string | undefined;
    connectionPointDescription?: string | undefined;
    customerName?: string | undefined;
}

export interface WorkOrderInfoDto {
    workTaskId?: number;
    wtmLink?: string | undefined;
    workOrderInfo?: WorkOrderInfo;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface AbsenceDTO {
    email?: string | undefined;
    startTime?: string;
    duration?: number;
    absenceName?: string | undefined;
    absenceType?: number;
}

export interface AdminUpdateTaskStatusCommand {
    taskId?: number;
    newStatus?: WorkTaskStatus;
    reason?: string | undefined;
    incidentNumber?: string | undefined;
}

export interface AlarmTypeDTO {
    alarmType?: AlarmTypeEnum;
    slaDate?: string;
}

export enum AlarmTypeEnum {
    F1 = "F1",
    F2 = "F2",
    F3 = "F3",
    F4 = "F4",
}

export enum AssetType2 {
    Netstation = "Netstation",
    CabelBox = "CabelBox",
    InstallationNumber = "InstallationNumber",
    HighVoltageNetstation = "HighVoltageNetstation",
    Meter = "Meter",
    Stretch = "Stretch",
}

export interface AttachmentDTO {
    filename?: string | undefined;
    createdOn?: string | undefined;
    uploadedBy?: string | undefined;
    isImage?: boolean;
}

export enum BaseWorkTaskTypeEnum {
    WorkTask = "WorkTask",
    SubWorkTask = "SubWorkTask",
    InternalWorkTask = "InternalWorkTask",
    Absence = "Absence",
}

export interface BookingLocationDTO {
    streetName?: string | undefined;
    houseNumber?: string | undefined;
    floor?: string | undefined;
    door?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    latitude?: number;
    longitude?: number;
}

export enum BookingState {
    Planned = "Planned",
    OnRoute = "OnRoute",
    OnGoing = "OnGoing",
    Complete = "Complete",
    Canceled = "Canceled",
}

export interface ChecklistDTO {
    workTaskCheckListId?: number;
    checkListName?: string | undefined;
    workTaskCheckListSections?: SectionDTO[] | undefined;
    order?: number;
    taskTypeChecklistId?: number | undefined;
    isRepeatable?: IsRepeatableEnum;
    isCompleted?: boolean;
    checkListHeader?: string | undefined;
    lastUpdated?: string;
}

export interface ChecklistsDTO {
    checklistsAreCreated?: boolean;
    checklists?: ChecklistDTO[] | undefined;
}

export interface ChildDTO {
    level?: number;
    workTaskId?: number;
    taskTypeName?: string | undefined;
    status?: WorkTaskStatus;
    assignedTechnician?: string | undefined;
}

export interface CloseBookingUnfinishedTaskDTO {
    workTaskId?: number;
    taskTypeName?: string | undefined;
    description?: string | undefined;
    status?: WorkTaskStatus;
    technicalResponsible?: PersonDTO;
}

export interface CloseWorkTaskBookingDTO {
    bookingId?: number;
    state?: BookingState;
    technician?: PersonDTO;
    appointmentStart?: string;
    appointmentEnd?: string;
}

export interface CommentDTO {
    commentId?: number | undefined;
    baseWorkTaskId?: number;
    authorName?: string | undefined;
    authorUsername?: string | undefined;
    text?: string | undefined;
    timeStamp?: string | undefined;
    isFlagged?: boolean;
}

export interface ComponentAttributeDTO {
    id?: number | undefined;
    isMandatory?: boolean;
    isEditable?: boolean;
    order?: number;
    attributeId?: number;
}

export interface ComponentAttributeLabelDTO {
    id?: number | undefined;
    label?: string | undefined;
    hintText?: string | undefined;
    isMandatory?: boolean;
    isEditable?: boolean;
    order?: number;
    attributeId?: number;
}

export interface ComponentDTO {
    id?: number | undefined;
    title?: string | undefined;
    order?: number;
    attributes?: ComponentAttributeDTO[] | undefined;
}

export interface ComponentLabelDTO {
    id?: number | undefined;
    title?: string | undefined;
    order?: number;
    attributes?: ComponentAttributeLabelDTO[] | undefined;
}

export interface ConcurrentTask {
    taskType?: ConcurrentTaskTypeEnum;
    assignedTo?: string | undefined;
}

export enum ConcurrentTaskTypeEnum {
    MainTask = "MainTask",
    SubWorkTask = "SubWorkTask",
}

export interface ContractorAgreementDTO2 {
    id?: number;
    voltages?: number[] | undefined;
    contactPersonName?: string | undefined;
    contactPersonPhoneNumber?: string | undefined;
    contractorCompanyName?: string | undefined;
    contractorCompanyPhoneNumber?: string | undefined;
    contactPersonEmail?: string | undefined;
    description?: string | undefined;
    lerNumber: string;
    withVoltage?: boolean;
    workingPeriodStart?: string | undefined;
    workingPeriodEnd?: string | undefined;
    verticalDistance?: string | undefined;
    horizontalDistance?: string | undefined;
    fromStation?: string | undefined;
    toStation?: string | undefined;
    stretches?: StretchDTO[] | undefined;
    signature?: string | undefined;
    signedBy?: string | undefined;
    signedDate?: string | undefined;
    technician?: string | undefined;
}

export interface CreateAndUpdateTaskTypeDTO2 {
    name?: string | undefined;
    description?: string | undefined;
    subWorkTaskType?: SubWorkTaskType;
    normTimeMin?: number;
    slaDays?: number;
    projectNumber_OneERP?: string | undefined;
    projectNumber_Opex?: string | undefined;
    projectNumber_Capex?: string | undefined;
    defaultDepartmentId?: number;
    enableContractorAgreements?: boolean;
    enableStretches?: boolean;
    emergencyOperationalFailure?: boolean;
    requiresPreparationTask?: boolean;
    isPreparationTask?: boolean;
    minTimeBeforeMainTaskDays?: number | undefined;
    maxTimeBeforeMainTaskDays?: number | undefined;
    mainTaskId?: number | undefined;
    specificAssetType?: string | undefined;
    taskTypeCategoryIds?: number[] | undefined;
    flsCallTypeId?: string | undefined;
    isDisabled?: boolean;
    taskTypeOwner?: string | undefined;
    taskTypeOwnerEmail?: string | undefined;
    sendTaskToPlanningOnCreation?: boolean;
    voltageLevelHigh?: boolean;
    voltageLevelMedium?: boolean;
    voltageLevelLow?: boolean;
    ignoreDrivingTimeWhenPlanned?: boolean;
    priority?: Priority;
    defaultRelationalTaskTypeId?: number | undefined;
    preventOrderItems?: boolean;
    workPermitRequirement?: WorkPermitRequirement;
}

export interface CreateAttributeValueDTO {
    attributeId?: number;
    taskComponentId?: number;
    value?: string | undefined;
    valueType?: string | undefined;
}

export interface CreateFieldMeasurementDTO {
    assetId?: string | undefined;
    latitude?: number;
    longitude?: number;
    description?: string | undefined;
}

export interface CreateInternalTaskDTO {
    location?: LocationDTO;
    createdByDepartment?: Department2;
    normTime?: number;
    timeFrom?: string;
    timeTo?: string;
    description?: string | undefined;
    taskTypeId?: number;
    ignoreDrivingTimeWhenPlanned?: boolean | undefined;
    workTaskResponsibleEmail?: string | undefined;
    workTaskResponsibleName?: string | undefined;
}

export interface CreateOrUpdateReasonCodeDTO {
    status?: WorkTaskStatus;
    text?: string | undefined;
}

export interface CreateQuestionDTO {
    text?: string | undefined;
    dataType?: string | undefined;
    questionType?: QuestionType;
    options?: CreateQuestionOptionDTO[] | undefined;
    isGisRelated?: boolean;
    helpText?: string | undefined;
    link?: string | undefined;
    linkText?: string | undefined;
}

export interface CreateQuestionOptionDTO {
    id?: number | undefined;
    questionOptionOrder?: number;
    questionOptionText?: string | undefined;
}

export interface CreateReusableComponentDTO {
    label?: string | undefined;
    inputType?: InputType;
    valueType?: string | undefined;
    hintText?: string | undefined;
    minLength?: number | undefined;
    maxLength?: number | undefined;
    isDeleted?: boolean;
}

export interface CreateWorkTaskDTO2 {
    taskLocation?: LocationDTO;
    description?: string | undefined;
    appointmentTimeStart?: string | undefined;
    appointmentTimeEnd?: string | undefined;
    status?: WorkTaskStatus;
    createdDateTime?: string;
    createdByDepartmentId?: number;
    taskTypeId?: number;
    notesForTechnician?: string | undefined;
    notesForPlanning?: string | undefined;
    assignedToEmail?: string | undefined;
    assignedToName?: string | undefined;
    deadline?: string | undefined;
    earliestStartDate?: string;
    plannedArrival?: string | undefined;
    plannedDuration?: number | undefined;
    normTimeMin?: number;
    remainingTimeMin?: number;
    assignedToDepartmentId?: number;
    gisRegion?: GisRegion2;
    parentId?: number | undefined;
    customerAppointment?: CustomerAppointmentDTO;
    projectNumber?: string | undefined;
    projectLegalEntityId?: string | undefined;
    componentValues?: CreateAttributeValueDTO[] | undefined;
    assetId?: string | undefined;
    assetGisMigrationId?: string | undefined;
    assetDynamicsFunctionalLocationId?: string | undefined;
    assetType?: AssetType2;
    assetPrimaryVoltage?: number;
    sendToPlanningOnCreation?: boolean;
    ignoreDrivingTimeWhenPlanned?: boolean | undefined;
    stretches?: StretchDTO[] | undefined;
    alternativeAssetId?: string | undefined;
    requestedAssigneeName?: string | undefined;
    proposedDateTimeStart?: string | undefined;
    alarmType?: AlarmTypeEnum;
    workTaskResponsibleName?: string | undefined;
    workTaskResponsibleEmail?: string | undefined;
    dynamicsWorkOrderNumber?: string | undefined;
    parentRelationshipType?: ParentRelationshipType;
    followUpDate?: string | undefined;
    minTimeBeforeMainTaskDays?: number | undefined;
    maxTimeBeforeMainTaskDays?: number | undefined;
    datesExcludedFromPlanning?: string[] | undefined;
}

export interface CustomerAppointmentBaseDTO {
    startDate?: string | undefined;
    endDate?: string | undefined;
    preferredTimeOfDay?: TimeOfDay;
    customerName?: string | undefined;
    customerPhoneNumber?: string | undefined;
    customerEmail?: string | undefined;
    customerRemarks?: string | undefined;
    appointmentRequest?: boolean | undefined;
}

export interface CustomerAppointmentDTO {
    startDate?: string | undefined;
    endDate?: string | undefined;
    preferredTimeOfDay?: TimeOfDay;
    customerName?: string | undefined;
    customerPhoneNumber?: string | undefined;
    customerEmail?: string | undefined;
    customerRemarks?: string | undefined;
    appointmentRequest?: boolean | undefined;
    approvedByPlanning?: boolean;
}

export interface CustomerAppointmentListItemDTO {
    appointmentRequest?: boolean | undefined;
    approvedByPlanning?: boolean;
    startDate?: string | undefined;
    endDate?: string | undefined;
    preferredTimeOfDay?: TimeOfDay;
}

export interface DayTaskDTO {
    workTaskId?: number;
    flsId?: number;
    status?: WorkTaskStatus;
    userRemarks?: string | undefined;
    reasonText?: string | undefined;
}

export interface Department {
    departmentId?: number;
    name?: string | undefined;
    isActive?: boolean;
    tags?: Tag[] | undefined;
    operationListStatuses?: DepartmentOperationListStatus[] | undefined;
    operationListPlanningSystems?: DepartmentOperationListPlanningSystem[] | undefined;
    created?: string | undefined;
    createdByEmail?: string | undefined;
    updated?: string | undefined;
    updatedByEmail?: string | undefined;
}

export enum Department2 {
    Planning = "Planning",
    Meterdata = "Meterdata",
    MeterWorkshop = "MeterWorkshop",
    CustomerConnection = "CustomerConnection",
    TechnicalSupport = "TechnicalSupport",
    Documentation = "Documentation",
    ControlRoom = "ControlRoom",
    Deleted_NetworkStrategy = "Deleted_NetworkStrategy",
    AdministrativeSupport = "AdministrativeSupport",
    SupportCenter = "SupportCenter",
    NetworkDesign = "NetworkDesign",
    ProjectEstablishment = "ProjectEstablishment",
    ProjectExecution = "ProjectExecution",
    Scada = "Scada",
    Automation = "Automation",
    Maintenance = "Maintenance",
    OnsiteSupport = "OnsiteSupport",
}

export interface DepartmentDTO {
    departmentId?: number;
    name?: string | undefined;
    isActive?: boolean;
    created?: string | undefined;
    createdByEmail?: string | undefined;
    updated?: string | undefined;
    updatedByEmail?: string | undefined;
}

export interface DepartmentOperationListPlanningSystem {
    departmentId?: number;
    planningSystem?: PlanningSystemEnum;
}

export interface DepartmentOperationListStatus {
    departmentId?: number;
    workTaskStatus?: WorkTaskStatus;
}

export enum EmailNotificationTypeEnum {
    StatusChange = "StatusChange",
    TaskChange = "TaskChange",
    TechnicianAssignment = "TechnicianAssignment",
}

export enum ExpenseCategoryEnum {
    OPEX = "OPEX",
    CAPEX = "CAPEX",
}

export interface FieldMeasurementDTO {
    id?: number;
    assetId?: string | undefined;
    latitude?: number;
    longitude?: number;
    description?: string | undefined;
    createdByEmail?: string | undefined;
    createdAt?: string;
}

export interface FileAnswerDTO {
    fileAnswerId?: number;
    fileName?: string | undefined;
    uploadedBy?: string | undefined;
    uploadedTime?: string | undefined;
    lastUpdated?: string;
}

export interface FileAnswerUploadDTO {
    answerId?: number | undefined;
    sectionQuestionId?: number | undefined;
    workTaskId?: number;
    files?: FileUploadDTO[] | undefined;
    answerTimeStampValue?: string | undefined;
}

export interface FileUploadDTO {
    fileName?: string | undefined;
    uploadedBy?: string | undefined;
}

export interface FromToDTO {
    from?: string;
    to?: string;
}

export interface FutureBookingDTO {
    bookingId?: number;
    state?: BookingState;
    person?: PersonDTO;
    appointmentStart?: string;
    appointmentEnd?: string;
}

export interface GetCloseBookingDialogueDTO {
    bookingId?: number;
    unfinishedTasks?: CloseBookingUnfinishedTaskDTO[] | undefined;
}

export interface GetCloseWorkTaskDialogueDTO {
    workTaskId?: number;
    openBookings?: CloseWorkTaskBookingDTO[] | undefined;
    plannedBookingCount?: number;
}

export interface GetWorkPlan6BookingDTO {
    id?: number;
    externalId?: string | undefined;
    appointmentStart?: string;
    appointmentEnd?: string;
    plannedArrival?: string;
    plannedDurationInMinutes?: number;
    state?: BookingState;
    isAppointmentFixed?: boolean;
    location?: BookingLocationDTO;
    workTasks?: WorkPlanItemDTO[] | undefined;
    isClosePrimary?: boolean;
    isDriveAllowed?: boolean;
    isBookingClosable?: boolean;
    workOrderNumber?: string | undefined;
    isAbsenceBooking?: boolean;
    absenceReason?: string | undefined;
}

export interface GetWorkPlanDTO6 {
    bookings?: GetWorkPlan6BookingDTO[] | undefined;
    unfinishedTasks?: WorkPlanItemDTO[] | undefined;
}

export interface GetWorkTaskBookingDTO {
    bookingId?: number;
    externalBookingId?: string | undefined;
    assignedTechnicianEmail?: string | undefined;
    assignedTechnicianName?: string | undefined;
    plannedDuration?: number;
    isAppointmentFixed?: boolean;
    bookingState?: BookingState;
    appointmentFrom?: string;
    appointmentTo?: string;
    plannedArrival?: string | undefined;
    isAbsenceBooking?: boolean;
    absenceReason?: string | undefined;
}

export enum GisRegion2 {
    North = "North",
    South = "South",
}

export enum InputType {
    Text = "Text",
    Number = "Number",
    Email = "Email",
    Stretch = "Stretch",
    YesNo = "YesNo",
    Link = "Link",
    DateTime = "DateTime",
    CableUnits = "CableUnits",
    StandardInstructions = "StandardInstructions",
}

export interface IntegrationMessageDTO {
    id?: string;
    occurredOn?: string;
    messageType?: string | undefined;
    payload?: string | undefined;
    processedDate?: string | undefined;
    failCount?: number;
    failedPermanently?: boolean;
    nextAttemptDate?: string | undefined;
    errorMessage?: string | undefined;
    traceParent?: string | undefined;
    integrationEventId?: string | undefined;
    correlationId?: string | undefined;
}

export interface InternalTaskDTO {
    workTaskId?: number;
    status?: WorkTaskStatus;
    taskLocation?: LocationDTO;
    timeFrom?: string;
    timeTo?: string;
    plannedArrival?: string | undefined;
    description?: string | undefined;
    createdByName?: string | undefined;
    createdByEmail?: string | undefined;
    workTaskResponsibleName?: string | undefined;
    workTaskResponsibleEmail?: string | undefined;
    taskType?: TaskTypeBaseDTO;
    normTimeMin?: number;
    dynamicsWorkOrderNumber?: string | undefined;
    planningSystem?: PlanningSystemEnum;
}

export interface InvalidChecklistDTO2 {
    checklistId?: number;
    invalidSectionIds?: number[] | undefined;
}

export enum IsRepeatableEnum {
    RepeatableWorkTaskChecklist = "RepeatableWorkTaskChecklist",
    RepeatableTaskTypeChecklist = "RepeatableTaskTypeChecklist",
    NotRepeatable = "NotRepeatable",
}

export interface LocationDTO {
    streetName?: string | undefined;
    houseNumber?: string | undefined;
    floor?: string | undefined;
    door?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
}

export interface MassCreationRequestDTO2 {
    assetType?: AssetType2;
    createdByDepartmentId?: number | undefined;
    taskTypeId?: number;
    notesForTechnician?: string | undefined;
    notesForPlanning?: string | undefined;
    workTaskResponsibleEmail?: string | undefined;
    workTaskResponsibleName?: string | undefined;
    earliestStartDate?: string;
    deadline?: string | undefined;
    normTimeMin?: number;
    assignedToDepartmentId?: number | undefined;
    gisRegion?: GisRegion2;
    projectNumber?: string | undefined;
    projectLegalEntityId?: string | undefined;
    ignoreDrivingTimeWhenPlanned?: boolean | undefined;
    componentValues?: CreateAttributeValueDTO[] | undefined;
    requestItems?: MassCreationRequestItemDTO[] | undefined;
}

export interface MassCreationRequestItemDTO {
    assetId?: string | undefined;
    assetGisMigrationId?: string | undefined;
    taskLocation?: LocationDTO;
    assetPrimaryVoltage?: number;
    description?: string | undefined;
    assetDynamicsFunctionalLocationId?: string | undefined;
}

export interface MassCreationStretchRequestDTO {
    assetType?: AssetType2;
    createdByDepartmentId?: number | undefined;
    taskTypeId?: number;
    notesForTechnician?: string | undefined;
    notesForPlanning?: string | undefined;
    workTaskResponsibleEmail?: string | undefined;
    workTaskResponsibleName?: string | undefined;
    earliestStartDate?: string;
    deadline?: string | undefined;
    normTimeMin?: number;
    assignedToDepartmentId?: number | undefined;
    gisRegion?: GisRegion2;
    projectNumber?: string | undefined;
    projectLegalEntityId?: string | undefined;
    ignoreDrivingTimeWhenPlanned?: boolean | undefined;
    componentValues?: CreateAttributeValueDTO[] | undefined;
    stretchItems?: MassCreationStretchRequestItemDTO[] | undefined;
}

export interface MassCreationStretchRequestItemDTO {
    assetFromId?: string | undefined;
    assetToId?: string | undefined;
    assetTypeTo?: AssetType2;
    assetTypeFrom?: AssetType2;
    taskLocation?: LocationDTO;
    assetPrimaryVoltage?: number;
    description?: string | undefined;
}

export enum MultiDayStatusEnum {
    OneDay = "OneDay",
    MultiDay = "MultiDay",
    MultiDayLastDay = "MultiDayLastDay",
}

export interface NearbyTaskItemDTO {
    workTaskId?: string | undefined;
    assetId?: string | undefined;
    status?: WorkTaskStatus;
    taskType?: TaskTypeBaseDTO;
    plannedArrival?: string | undefined;
    createdByName?: string | undefined;
}

export interface NearbyTasksDTO {
    openTasksOnSameAsset?: NearbyTaskItemDTO[] | undefined;
    openTasksOnDifferentAsset?: NearbyTaskItemDTO[] | undefined;
    processedTasksOnSameAsset?: NearbyTaskItemDTO[] | undefined;
}

export enum OrderByColumnEnum {
    WorkTaskId = "WorkTaskId",
    Type = "Type",
    TaskLocation = "TaskLocation",
    AppointmentTimeStart = "AppointmentTimeStart",
    AppointmentTimeEnd = "AppointmentTimeEnd",
    PlannedArrival = "PlannedArrival",
    PlannedDuration = "PlannedDuration",
    CreatedAt = "CreatedAt",
    EarliestStartDate = "EarliestStartDate",
    Deadline = "Deadline",
    CreatedByName = "CreatedByName",
    CreatedByEmail = "CreatedByEmail",
    AssignedToEmail = "AssignedToEmail",
    AssignedToName = "AssignedToName",
    AssignedToCaseWorkerEmail = "AssignedToCaseWorkerEmail",
    AssignedToCaseWorkerName = "AssignedToCaseWorkerName",
    Status = "Status",
    AssetId = "AssetId",
    AssetType = "AssetType",
    AssignedToDepartment = "AssignedToDepartment",
    ProjectNumber = "ProjectNumber",
    NotesForPlanning = "NotesForPlanning",
    CustomerAppointment = "CustomerAppointment",
    ParentId = "ParentId",
    HasSubTasks = "HasSubTasks",
    HasRelatedTasks = "HasRelatedTasks",
    GisRegion = "GisRegion",
    TagId = "TagId",
    ZipCode = "ZipCode",
    AppointmentRequest = "AppointmentRequest",
    CompletedDate = "CompletedDate",
    RequestedAssigneeName = "RequestedAssigneeName",
    WorkTaskResponsibleName = "WorkTaskResponsibleName",
    FollowUpDate = "FollowUpDate",
    LastUpdated = "LastUpdated",
    DynamicsWorkOrderNumber = "DynamicsWorkOrderNumber",
    PlanningSystem = "PlanningSystem",
    NotesForTechnician = "NotesForTechnician",
}

export enum OrderByEnum {
    Asc = "Asc",
    Desc = "Desc",
}

export enum ParentRelationshipType {
    FollowUpToParent = "FollowUpToParent",
    ExecutedWithParent = "ExecutedWithParent",
    PreparationForParent = "PreparationForParent",
    FollowUpSameWorkOrderAsParent = "FollowUpSameWorkOrderAsParent",
}

export interface PersonDTO {
    name?: string | undefined;
    email?: string | undefined;
}

export enum PlanningEventState {
    Unplanned = "Unplanned",
    Planned = "Planned",
    Pause = "Pause",
    Complete = "Complete",
}

export enum PlanningSystemEnum {
    Unknown = "Unknown",
    FLS = "FLS",
    D365CE = "D365CE",
}

export enum Priority {
    Normal = "Normal",
    Low = "Low",
    High = "High",
    Urgent = "Urgent",
}

export interface QandADTO {
    answerId?: number | undefined;
    sectionQuestionId?: number | undefined;
    questionText?: string | undefined;
    questionHelpText?: string | undefined;
    questionType?: string | undefined;
    questionOptionsDTOs?: QuestionOptionDTO[] | undefined;
    answerTextValue?: string | undefined;
    answerFilenameValue?: string | undefined;
    answerIntValue?: number | undefined;
    answerDoubleValue?: number | undefined;
    answerTimeStampValue?: string | undefined;
    answerUpdatedByEmail?: string | undefined;
    isMandatory?: boolean;
    link?: string | undefined;
    linkText?: string | undefined;
    fileAnswerDTOs?: FileAnswerDTO[] | undefined;
    answerQuestionOptionValue?: number | undefined;
    lastUpdated?: string;
}

export interface QuestionDTO {
    id?: number;
    text?: string | undefined;
    dataType?: string | undefined;
    questionType?: QuestionType;
    options?: QuestionOptionDTO[] | undefined;
    isGisRelated?: boolean;
    helpText?: string | undefined;
    link?: string | undefined;
    linkText?: string | undefined;
}

export interface QuestionOptionDTO {
    id?: number;
    questionOptionOrder?: number;
    questionOptionText?: string | undefined;
    isDeleted?: boolean;
    lastUpdated?: string;
}

export enum QuestionType {
    Header = "Header",
    Text = "Text",
    Number = "Number",
    SingleChoice = "SingleChoice",
    Confirm = "Confirm",
    Date = "Date",
    Image = "Image",
    DateTime = "DateTime",
}

export interface ReasonCodeDTO {
    reasonCodeId?: number;
    reasonText?: string | undefined;
    status?: WorkTaskStatus;
    order?: number;
    sendToDepartmentId?: number | undefined;
    sendToCreatingDepartment?: boolean;
}

export interface ReuseableComponentAttributeDTO {
    id?: number;
    label?: string | undefined;
    inputType?: InputType;
    valueType?: string | undefined;
    hintText?: string | undefined;
    minLength?: number | undefined;
    maxLength?: number | undefined;
    isDeleted?: boolean;
}

export interface RevisitDTO {
    workTaskId?: number;
    startDate?: string | undefined;
    endDate?: string | undefined;
    description?: string | undefined;
    requestedTechnician?: string | undefined;
    remainingTimeMin?: number;
    useForPlanning?: boolean;
}

export interface SectionDTO {
    name?: string | undefined;
    headerText?: string | undefined;
    sectionType?: string | undefined;
    sectionId?: number;
    taskSectionId?: number;
    isRepeatable?: boolean | undefined;
    isRepeatable2?: IsRepeatableEnum;
    dependsOnQuestionAnswerId?: number | undefined;
    dependsOnSectionQuestionId?: number | undefined;
    dependsOnQuestionOptionId?: number | undefined;
    dependsOnQuestionOptionInvert?: boolean | undefined;
    order?: number;
    answerDTOList?: QandADTO[] | undefined;
    isCompleted?: boolean;
    lastUpdated?: string;
}

export interface SectionQuestionDTO {
    sectionQuestionId?: number | undefined;
    questionId?: number;
    order?: number;
    isMandatory?: boolean;
}

export interface SectionQuestionTextDTO {
    sectionQuestionId?: number | undefined;
    questionId?: number;
    order?: number;
    isMandatory?: boolean;
    text?: string | undefined;
    questionType?: QuestionType;
}

export interface SimulateDto {
    assignedToEmail?: string | undefined;
    assignedToName?: string | undefined;
    plannedArrival?: string;
    plannedDuration?: number;
    isFixed?: boolean;
    numberOfDays?: number;
}

export interface StretchDTO {
    from: string;
    assetTypeFrom?: AssetType2;
    to: string;
    assetTypeTo?: AssetType2;
    workTaskId?: number | undefined;
}

export interface SubWorkTaskDTO {
    id?: number;
    taskTypeId?: number;
    assignedTechnician?: string | undefined;
    status?: WorkTaskStatus;
}

export interface SubWorkTaskDetailedDTO2 {
    workTaskId?: string | undefined;
    mainTask?: WorkTaskDTO2;
    createdByName?: string | undefined;
    createdByEmail?: string | undefined;
    workTaskResponsibleName?: string | undefined;
    workTaskResponsibleEmail?: string | undefined;
    taskType?: TaskTypeBaseDTO;
    status?: WorkTaskStatus;
    assignedToEmail?: string | undefined;
    assignedToName?: string | undefined;
}

export enum SubWorkTaskType {
    NoSubWorkTask = "NoSubWorkTask",
    SameAsMainTask = "SameAsMainTask",
    LiveVoltageTask = "LiveVoltageTask",
}

export interface Tag {
    id?: number;
    tagText?: string | undefined;
    departments?: Department[] | undefined;
}

export interface TagDTO {
    id?: number;
    tagText?: string | undefined;
}

export interface TaskBookingInfo {
    technicalResponsible?: PersonDTO;
    numberOfTechsBookedOnTaskToday?: number;
    numberOfBookingsOnTask?: number;
    otherBookedTechsToday?: PersonDTO[] | undefined;
}

export interface TaskComponentAttributeDTO {
    attributeId?: number;
    label?: string | undefined;
    inputType?: InputType;
    valueType?: string | undefined;
    isMandatory?: boolean;
    isEditable?: boolean;
    hintText?: string | undefined;
    minLength?: number | undefined;
    maxLength?: number | undefined;
    order?: number;
    taskComponentId?: number;
}

export interface TaskComponentAttributeValueDTO {
    id?: number;
    reusableComponentAttributeId?: number;
    workTaskId?: number;
    attributeId?: number;
    label?: string | undefined;
    inputType?: InputType;
    value?: string | undefined;
    isMandatory?: boolean;
    isEditable?: boolean;
    order?: number;
    taskComponentId?: number;
}

export interface TaskComponentDTO {
    id?: number;
    title?: string | undefined;
    order?: number;
    attributes?: TaskComponentAttributeDTO[] | undefined;
}

export interface TaskComponentValueDTO {
    id?: number;
    title?: string | undefined;
    order?: number;
    attributes?: TaskComponentAttributeValueDTO[] | undefined;
}

export interface TaskListInfoDTO {
    tags?: TagDTO[] | undefined;
    departments?: DepartmentDTO[] | undefined;
    taskTypes?: TaskTypeBaseDTO[] | undefined;
    workTaskStatusesForOperationList?: WorkTaskStatus[] | undefined;
    planningSystemsForOperationList?: PlanningSystemEnum[] | undefined;
}

export interface TaskListRequestDTO {
    orderByColumn?: OrderByColumnEnum;
    sortOrder?: OrderByEnum;
    globalSearchTerm?: string | undefined;
    workTaskIdFilter?: string | undefined;
    taskTypesFilter?: number[] | undefined;
    zipCodeFilter?: string | undefined;
    assetIdFilter?: string | undefined;
    regionFilter?: GisRegion2[] | undefined;
    notesForPlanningFilter?: string | undefined;
    notesForTechnicianFilter?: string | undefined;
    dynamicsWorkOrderNumberFilter?: string | undefined;
    projectNumberFilter?: string | undefined;
    createdByFilter?: string | undefined;
    createdByEmailFilter?: string | undefined;
    assignedToTechnicianFilter?: string | undefined;
    assignedToTechnicianEmailFilter?: string | undefined;
    assignedToCaseWorkerFilter?: string | undefined;
    departmentIdFilter?: number[] | undefined;
    taskStatusFilter?: WorkTaskStatus[] | undefined;
    assetTypeFilter?: AssetType2[] | undefined;
    tagId?: number | undefined;
    earliestStartDateFilter?: FromToDTO;
    deadlineFilter?: FromToDTO;
    plannedArrivalFilter?: FromToDTO;
    createdDateFilter?: FromToDTO;
    completedDateFilter?: FromToDTO;
    followUpDateFilter?: FromToDTO;
    lastUpdatedFilter?: FromToDTO;
    locationFilter?: string | undefined;
    workTaskResponsibleNameFilter?: string | undefined;
    appointmentRequestFilter?: boolean[] | undefined;
    planningSystemFilter?: PlanningSystemEnum[] | undefined;
    pageSize?: number;
    page?: number;
}

export interface TaskListResponseDTO {
    tasks?: WorkTaskListItemDTO3[] | undefined;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
}

export interface TaskTypeBaseDTO {
    id?: number;
    name?: string | undefined;
    projectNumber_OneERP?: string | undefined;
    projectNumber_Opex?: string | undefined;
    projectNumber_Capex?: string | undefined;
    taskTypeCategories?: TaskTypeCategoryDTO[] | undefined;
}

export interface TaskTypeCategoryDTO {
    id?: number;
    name?: string | undefined;
    taskTypeCategoryType?: TaskTypeCategoryTypeEnum;
}

export enum TaskTypeCategoryTypeEnum {
    WorkTask = "WorkTask",
    Internal = "Internal",
    LiveVoltage = "LiveVoltage",
    NonSchedulable = "NonSchedulable",
}

export interface TaskTypeCheckListDTO {
    taskTypeCheckListId?: number | undefined;
    checkListName?: string | undefined;
    taskTypeSections?: TaskTypeSectionDTO[] | undefined;
    order?: number;
    isRepeatable?: boolean;
    checkListHeader?: string | undefined;
}

export interface TaskTypeCheckListTextDTO {
    taskTypeCheckListId?: number;
    checkListName?: string | undefined;
    taskTypeSections?: TaskTypeSectionTextDTO[] | undefined;
    order?: number;
    isRepeatable?: boolean;
    checkListHeader?: string | undefined;
}

export interface TaskTypeDetailedDTO2 {
    id?: number;
    name?: string | undefined;
    projectNumber_OneERP?: string | undefined;
    projectNumber_Opex?: string | undefined;
    projectNumber_Capex?: string | undefined;
    taskTypeCategories?: TaskTypeCategoryDTO[] | undefined;
    description?: string | undefined;
    subWorkTaskType?: SubWorkTaskType;
    normTimeMin?: number;
    slaDays?: number;
    defaultDepartment?: DepartmentDTO;
    enableContractorAgreements?: boolean;
    enableStretches?: boolean;
    emergencyOperationalFailure?: boolean;
    requiresPreparationTask?: boolean;
    isPreparationTask?: boolean;
    minTimeBeforeMainTaskDays?: number | undefined;
    maxTimeBeforeMainTaskDays?: number | undefined;
    mainTaskId?: number | undefined;
    specificAssetType?: string | undefined;
    flsCallTypeId?: string | undefined;
    isDisabled?: boolean;
    taskComponents?: TaskComponentDTO[] | undefined;
    taskTypeOwner?: string | undefined;
    taskTypeOwnerEmail?: string | undefined;
    sendTaskToPlanningOnCreation?: boolean;
    voltageLevelHigh?: boolean;
    voltageLevelMedium?: boolean;
    voltageLevelLow?: boolean;
    ignoreDrivingTimeWhenPlanned?: boolean;
    priority?: Priority;
    defaultRelationalTaskTypeId?: number | undefined;
    updatedByEmail?: string | undefined;
    lastUpdated?: string | undefined;
    isMeterTaskType?: boolean;
    preventOrderItems?: boolean;
    workPermitRequirement?: WorkPermitRequirement;
    externalResources?: TaskTypeExternalResourceDTO[] | undefined;
}

export interface TaskTypeExternalResourceDTO {
    id?: number | undefined;
    url?: string | undefined;
    name?: string | undefined;
    order?: number;
}

export interface TaskTypePickerDTO2 {
    taskTypeCategories?: TaskTypeCategoryDTO[] | undefined;
    specificAssetTypes?: string[] | undefined;
    taskTypeDTOs?: TaskTypeDetailedDTO2[] | undefined;
}

export interface TaskTypeSectionDTO {
    sectionId?: number | undefined;
    name?: string | undefined;
    order?: number;
    isRepeatable?: boolean | undefined;
    dependsOnQuestionSectionQuestionId?: number | undefined;
    dependsOnQuestionOptionId?: number | undefined;
    dependsOnQuestionOptionInvert?: boolean | undefined;
    questions?: SectionQuestionDTO[] | undefined;
}

export interface TaskTypeSectionTextDTO {
    sectionId?: number | undefined;
    name?: string | undefined;
    order?: number;
    isRepeatable?: boolean | undefined;
    dependsOnQuestionSectionQuestionId?: number | undefined;
    dependsOnQuestionOptionId?: number | undefined;
    dependsOnQuestionOptionInvert?: boolean | undefined;
    questions?: SectionQuestionTextDTO[] | undefined;
}

export interface TechnicianEventDTO {
    workTaskId?: number;
    taskStart?: string;
    taskEnd?: string;
    plannedArrival?: string;
    isAppointmentFixed?: boolean;
    state?: PlanningEventState;
    baseWorkTaskType?: BaseWorkTaskTypeEnum;
    status?: WorkTaskStatus;
}

export interface TechnicianScheduleDTO {
    name?: string | undefined;
    events?: TechnicianEventDTO[] | undefined;
}

export enum TimeOfDay {
    Morning = "Morning",
    Noon = "Noon",
    Midday = "Midday",
    Afternoon = "Afternoon",
}

export interface UpdateAnswerDTO {
    answerId?: number | undefined;
    sectionQuestionId?: number | undefined;
    workTaskId?: number | undefined;
    answerTextValue?: string | undefined;
    answerIntValue?: number | undefined;
    answerDoubleValue?: number | undefined;
    answerDateTimeValue?: string | undefined;
    filename?: string | undefined;
    answerQuestionOptionId?: number | undefined;
    answerTimeStampValue?: string | undefined;
}

export interface UpdateAttributeValueDTO {
    id?: number;
    value?: string | undefined;
}

export interface UpdateQuestionDTO {
    options?: UpdateQuestionOptionDTO[] | undefined;
    helpText?: string | undefined;
    link?: string | undefined;
    linkText?: string | undefined;
}

export interface UpdateQuestionOptionDTO {
    id?: number | undefined;
    questionOptionOrder?: number;
    questionOptionText?: string | undefined;
}

export interface UpdateReasonCodeStatusDTO2 {
    reasonCodeStatusId?: number | undefined;
    reasonCodeId?: number;
    sendToDepartmentId?: number | undefined;
    sendToCreatingDepartment?: boolean;
    order?: number;
}

export interface UpdateReuseableComponentAttributeDTO {
    label?: string | undefined;
    inputType?: InputType;
    valueType?: string | undefined;
    hintText?: string | undefined;
    minLength?: number | undefined;
    maxLength?: number | undefined;
    isDeleted?: boolean;
}

export interface UpdateWorkTaskDTO2 {
    description?: string | undefined;
    earliestStartDate?: string | undefined;
    deadline?: string | undefined;
    assignedToDepartmentId?: number | undefined;
    customerAppointment?: CustomerAppointmentDTO;
    normTimeMin?: number | undefined;
    remainingTimeMin?: number | undefined;
    taskLocation?: LocationDTO;
    notesForPlanning?: string | undefined;
    notesForTechnician?: string | undefined;
    accessConditions?: string | undefined;
    componentAttributes?: UpdateAttributeValueDTO[] | undefined;
    projectLegalEntityId?: string | undefined;
    projectNumber?: string | undefined;
    stretches?: StretchDTO[] | undefined;
    workTaskResponsibleName?: string | undefined;
    workTaskResponsibleEmail?: string | undefined;
    dynamicsWorkOrderNumber?: string | undefined;
    assignedToName?: string | undefined;
    assignedToEmail?: string | undefined;
    plannedArrival?: string | undefined;
    parentId?: number | undefined;
    parentRelationshipType?: ParentRelationshipType;
    followUpDate?: string | undefined;
    planningSystem?: PlanningSystemEnum;
    minTimeBeforeMainTaskDays?: number | undefined;
    maxTimeBeforeMainTaskDays?: number | undefined;
    alarmType?: AlarmTypeEnum;
    completionDate?: string | undefined;
    datesExcludedFromPlanning?: string[] | undefined;
}

export enum WorkPermitRequirement {
    NotRequired = "NotRequired",
    Required = "Required",
}

export interface WorkPlanItemDTO {
    workTaskId?: number;
    flsId?: number;
    tasklocation?: LocationDTO;
    status?: WorkTaskStatus;
    plannedArrival?: string | undefined;
    notes?: string | undefined;
    taskType?: TaskTypeBaseDTO;
    assetId?: string | undefined;
    assetGisMigrationId?: string | undefined;
    assetDynamicsFunctionalLocationId?: string | undefined;
    appointmentTimeEnd?: string | undefined;
    appointmentTimeStart?: string | undefined;
    hasSubTasks?: boolean;
    concurrentTasks?: ConcurrentTask[] | undefined;
    baseWorkTaskType?: BaseWorkTaskTypeEnum;
    multiDayStatus?: MultiDayStatusEnum;
    notesForTechnician?: string | undefined;
    bookingInfo?: TaskBookingInfo;
    futureBookings?: FutureBookingDTO[] | undefined;
    isCloseAllowed?: boolean;
    isClosePrimary?: boolean;
    isTeamTask?: boolean;
}

export interface WorkPlanItemStatusDTO {
    workTaskId?: number;
    flsId?: number;
    status: WorkTaskStatus;
    reasonCode?: ReasonCodeDTO;
    userRemarks?: string | undefined;
    reasonCodeText?: string | undefined;
}

export interface WorkTaskDTO2 {
    id?: string | undefined;
    taskType?: TaskTypeDetailedDTO2;
    taskLocation?: LocationDTO;
    createdAt?: string;
    createdByName?: string | undefined;
    createdByEmail?: string | undefined;
    workTaskResponsibleName?: string | undefined;
    workTaskResponsibleEmail?: string | undefined;
    status?: WorkTaskStatus;
    assetId?: string | undefined;
    assetGisMigrationId?: string | undefined;
    assetDynamicsFunctionalLocationId?: string | undefined;
    assetType?: AssetType2;
    description?: string | undefined;
    normTimeMin?: number;
    remainingTimeMin?: number;
    earliestStartDate?: string | undefined;
    deadline?: string | undefined;
    commentsCount?: number;
    assignedToDepartment?: DepartmentDTO;
    projectNumber?: string | undefined;
    projectLegalEntityId?: string | undefined;
    notesForTechnician?: string | undefined;
    notesForPlanning?: string | undefined;
    dynamicsWorkOrderNumber?: string | undefined;
    accessConditions?: string | undefined;
    primaryVoltage?: number;
    parent?: WorkTaskRelativeDTO;
    bookings?: GetWorkTaskBookingDTO[] | undefined;
    children?: WorkTaskRelativeDTO[] | undefined;
    customerAppointment?: CustomerAppointmentDTO;
    hasSubTasks?: boolean;
    reasonCode?: ReasonCodeDTO;
    statusTransactionMessage?: string | undefined;
    components?: TaskComponentValueDTO[] | undefined;
    plannedArrival?: string | undefined;
    plannedDuration?: number | undefined;
    assignedToEmail?: string | undefined;
    assignedToName?: string | undefined;
    appointmentTimeStart?: string | undefined;
    appointmentTimeEnd?: string | undefined;
    subWorkTasks?: SubWorkTaskDTO[] | undefined;
    gisRegion?: GisRegion2;
    stretches?: StretchDTO[] | undefined;
    completedDate?: string | undefined;
    ignoreDrivingTimeWhenPlanned?: boolean | undefined;
    relatedTasks?: ChildDTO[] | undefined;
    alarmType?: AlarmTypeEnum;
    isMeterTask?: boolean;
    expenseCategory?: ExpenseCategoryEnum;
    containerId?: number | undefined;
    containerWorkTaskId?: number | undefined;
    isTeamTask?: boolean;
    parentRelationshipType?: ParentRelationshipType;
    followUpDate?: string | undefined;
    planningSystem?: PlanningSystemEnum;
    minTimeBeforeMainTaskDays?: number | undefined;
    maxTimeBeforeMainTaskDays?: number | undefined;
    datesExcludedFromPlanning?: string[] | undefined;
}

export interface WorkTaskDepartmentDTO2 {
    workTaskId?: number;
    newDepartmentId?: number;
}

export interface WorkTaskListItemDTO3 {
    id?: string | undefined;
    description?: string | undefined;
    taskTypeName?: string | undefined;
    taskTypeId?: number;
    taskLocation?: LocationDTO;
    appointmentTimeStart?: string | undefined;
    appointmentTimeEnd?: string | undefined;
    plannedArrival?: string | undefined;
    plannedDuration?: number | undefined;
    alarmType?: AlarmTypeEnum;
    createdAt?: string;
    earliestStartDate?: string | undefined;
    deadline?: string | undefined;
    createdByName?: string | undefined;
    createdByEmail?: string | undefined;
    workTaskResponsibleName?: string | undefined;
    workTaskResponsibleEmail?: string | undefined;
    assignedToEmail?: string | undefined;
    assignedToName?: string | undefined;
    assignedToCaseWorkerEmail?: string | undefined;
    assignedToCaseWorkerName?: string | undefined;
    status?: WorkTaskStatus;
    assetId?: string | undefined;
    assetGisMigrationId?: string | undefined;
    assetDynamicsFunctionalLocationId?: string | undefined;
    assetType?: AssetType2;
    assignedToDepartment?: DepartmentDTO;
    projectNumber?: string | undefined;
    notesForTechnician?: string | undefined;
    notesForPlanning?: string | undefined;
    dynamicsWorkOrderNumber?: string | undefined;
    customerAppointment?: CustomerAppointmentListItemDTO;
    parentId?: string | undefined;
    hasSubTasks?: boolean;
    isTeamTask?: boolean;
    hasRelatedTasks?: boolean;
    baseWorkTaskType?: BaseWorkTaskTypeEnum;
    gisRegion?: GisRegion2;
    tagId?: number | undefined;
    completedDate?: string | undefined;
    flaggedCommentText?: string | undefined;
    alternativeAssetId?: string | undefined;
    requestedAssigneeName?: string | undefined;
    isMeterTask?: boolean;
    hasRevisit?: boolean;
    followUpDate?: string | undefined;
    lastUpdated?: string;
    planningSystem?: PlanningSystemEnum;
}

export interface WorkTaskProjectDTO {
    projectLegalEntityId?: string | undefined;
    projectNumber?: string | undefined;
}

export interface WorkTaskRelativeDTO {
    workTaskId?: number;
    parentId?: number | undefined;
    taskTypeId?: number;
    taskTypeName?: string | undefined;
    status?: WorkTaskStatus;
    assignedToName?: string | undefined;
    assetId?: string | undefined;
    dynamicsWorkOrderNumber?: string | undefined;
    parentRelationshipType?: ParentRelationshipType;
    earliestStartDate?: string | undefined;
    deadline?: string | undefined;
    plannedArrival?: string | undefined;
    minDaysToParent?: number | undefined;
    maxDaysToParent?: number | undefined;
}

export enum WorkTaskStatus {
    Created = "Created",
    ReadyForPlanning = "ReadyForPlanning",
    Planned = "Planned",
    PlannedAppointment = "PlannedAppointment",
    OnRoute = "OnRoute",
    Ongoing = "Ongoing",
    Pause = "Pause",
    Completed = "Completed",
    Processed = "Processed",
    Canceled = "Canceled",
}

export interface WorkTaskStatusDTO {
    workTaskId?: number;
    workTaskHasSubtasks?: boolean;
    status: WorkTaskStatus;
    reasonCode?: ReasonCodeDTO;
    userRemarks?: string | undefined;
    reasonCodeText?: string | undefined;
    isMeterTask?: boolean;
}

export enum AssetTypeFilter {
    Netstation = "Netstation",
    CabelBox = "CabelBox",
    InstallationNumber = "InstallationNumber",
    HighVoltageNetstation = "HighVoltageNetstation",
}

export interface CreateNewsDTO {
    title?: string | undefined;
    description?: string | undefined;
    link?: string | undefined;
    newsType: CreateNewsDTONewsType;
    notifyUsers?: boolean;
    newsTarget?: CreateNewsDTONewsTarget;
}

export enum CreateNewsDTONewsTarget {
    All = "All",
    Technician = "Technician",
    Office = "Office",
    Admin = "Admin",
}

export enum CreateNewsDTONewsType {
    Standard = "Standard",
    OperationalError = "OperationalError",
    ResolvedError = "ResolvedError",
}

export interface CreatePortalLinkDto {
    link?: string | undefined;
    linkText?: string | undefined;
    order?: number;
}

export interface FromToDTO2 {
    from?: string | undefined;
    to?: string | undefined;
}

export interface NewsDTO {
    id?: number;
    title?: string | undefined;
    description?: string | undefined;
    link?: string | undefined;
    newsType?: NewsDTONewsType;
    isRead?: boolean;
    lastUpdated?: string | undefined;
    createdByEmail?: string | undefined;
    createdByName?: string | undefined;
    newsTarget?: NewsDTONewsTarget;
    notifyUsers?: boolean;
}

export enum NewsDTONewsTarget {
    All = "All",
    Technician = "Technician",
    Office = "Office",
    Admin = "Admin",
}

export enum NewsDTONewsType {
    Standard = "Standard",
    OperationalError = "OperationalError",
    ResolvedError = "ResolvedError",
}

export interface PortalLinkDto {
    id?: number;
    link?: string | undefined;
    linkText?: string | undefined;
    order?: number;
}

export enum ProfileDTO2Region {
    North = "North",
    South = "South",
    OneERP = "OneERP",
}

export enum ProfileDTO2Role {
    Technician = "Technician",
    Office = "Office",
    Admin = "Admin",
    Developer = "Developer",
    CombinedTechnicianAndOffice = "CombinedTechnicianAndOffice",
}

export enum RegionFilter {
    North = "North",
    South = "South",
}

export enum Role {
    Technician = "Technician",
    Office = "Office",
    Admin = "Admin",
    Developer = "Developer",
    CombinedTechnicianAndOffice = "CombinedTechnicianAndOffice",
}

export interface SaveProfileDTO2 {
    email?: string | undefined;
    name?: string | undefined;
    role?: SaveProfileDTO2Role;
    departmentId?: number | undefined;
    phone?: string | undefined;
}

export enum SaveProfileDTO2Role {
    Technician = "Technician",
    Office = "Office",
    Admin = "Admin",
    Developer = "Developer",
    CombinedTechnicianAndOffice = "CombinedTechnicianAndOffice",
}

export interface TaskListConfigurationDTO2 {
    tagId?: number;
    hiddenColumns?: string[] | undefined;
    columnOrder?: string[] | undefined;
}

export interface TaskListCustomFilterDTO {
    name?: string | undefined;
    isSelected?: boolean | undefined;
    workTaskIdFilter?: string | undefined;
    taskTypesFilter?: number[] | undefined;
    zipCodeFilter?: string | undefined;
    assetIdFilter?: string | undefined;
    regionFilter?: RegionFilter[] | undefined;
    notesForPlanningFilter?: string | undefined;
    projectNumberFilter?: string | undefined;
    createdByFilter?: string | undefined;
    assignedToTechnicianFilter?: string | undefined;
    assignedToTechnicianEmailFilter?: string | undefined;
    assignedToCaseWorkerFilter?: string | undefined;
    departmentIdFilter?: number[] | undefined;
    taskStatusFilter?: TaskStatusFilter[] | undefined;
    assetTypeFilter?: AssetTypeFilter[] | undefined;
    earliestStartDateFilter?: FromToDTO2;
    deadlineFilter?: FromToDTO2;
    plannedArrivalFilter?: FromToDTO2;
    createdDateFilter?: FromToDTO2;
    completedDateFilter?: FromToDTO2;
    locationFilter?: string | undefined;
    workTaskResponsibleNameFilter?: string | undefined;
}

export interface TaskListCustomFilterDTO2 {
    name?: string | undefined;
    isSelected?: boolean | undefined;
    workTaskIdFilter?: string | undefined;
    taskTypesFilter?: number[] | undefined;
    zipCodeFilter?: string | undefined;
    assetIdFilter?: string | undefined;
    regionFilter?: regionFilter[] | undefined;
    notesForPlanningFilter?: string | undefined;
    projectNumberFilter?: string | undefined;
    createdByFilter?: string | undefined;
    assignedToTechnicianFilter?: string | undefined;
    assignedToTechnicianEmailFilter?: string | undefined;
    assignedToCaseWorkerFilter?: string | undefined;
    departmentIdFilter?: number[] | undefined;
    taskStatusFilter?: taskStatusFilter[] | undefined;
    assetTypeFilter?: assetTypeFilter[] | undefined;
    earliestStartDateFilter?: FromToDTO2;
    deadlineFilter?: FromToDTO2;
    plannedArrivalFilter?: FromToDTO2;
    createdDateFilter?: FromToDTO2;
    completedDateFilter?: FromToDTO2;
    locationFilter?: string | undefined;
    workTaskResponsibleNameFilter?: string | undefined;
    type?: TaskListCustomFilterDTO2Type;
    isAllTasksSelected?: boolean;
}

export enum TaskListCustomFilterDTO2Type {
    User = "User",
    Department = "Department",
    UserAllTasks = "UserAllTasks",
    DepartmentAllTasks = "DepartmentAllTasks",
}

export enum TaskStatusFilter {
    Created = "Created",
    ReadyForPlanning = "ReadyForPlanning",
    Planned = "Planned",
    PlannedAppointment = "PlannedAppointment",
    OnRoute = "OnRoute",
    Ongoing = "Ongoing",
    Pause = "Pause",
    Completed = "Completed",
    Processed = "Processed",
    Canceled = "Canceled",
}

export interface UpdateNewsDTO {
    id?: number;
    title?: string | undefined;
    description?: string | undefined;
    link?: string | undefined;
    newsType: UpdateNewsDTONewsType;
    newsTarget?: UpdateNewsDTONewsTarget;
}

export enum UpdateNewsDTONewsTarget {
    All = "All",
    Technician = "Technician",
    Office = "Office",
    Admin = "Admin",
}

export enum UpdateNewsDTONewsType {
    Standard = "Standard",
    OperationalError = "OperationalError",
    ResolvedError = "ResolvedError",
}

export interface UpdateProfileDTO2 {
    departmentId?: number | undefined;
    name?: string | undefined;
    region?: UpdateProfileDTO2Region;
    favoriteWarehouseId?: string | undefined;
    phone?: string | undefined;
    isAutomaticNotificationsEnabled?: boolean;
}

export enum UpdateProfileDTO2Region {
    North = "North",
    South = "South",
    OneERP = "OneERP",
}

export interface UserDTO {
    email?: string | undefined;
    name?: string | undefined;
}

export enum assetTypeFilter {
    Netstation = "Netstation",
    CabelBox = "CabelBox",
    InstallationNumber = "InstallationNumber",
    HighVoltageNetstation = "HighVoltageNetstation",
}

export enum regionFilter {
    North = "North",
    South = "South",
}

export enum taskStatusFilter {
    Created = "Created",
    ReadyForPlanning = "ReadyForPlanning",
    Planned = "Planned",
    PlannedAppointment = "PlannedAppointment",
    OnRoute = "OnRoute",
    Ongoing = "Ongoing",
    Pause = "Pause",
    Completed = "Completed",
    Processed = "Processed",
    Canceled = "Canceled",
}

export interface AddFavoriteItemRequest {
    itemId?: string | undefined;
    groupIds?: number[] | undefined;
}

export interface CategoryDTO {
    legalEntityId: string;
    id: string;
    name?: string | undefined;
    region: Region2;
}

export interface CategoryDTO2 {
    legalEntityId: string;
    id: string;
    name?: string | undefined;
}

export interface CategoryLinkDTO {
    id?: string | undefined;
    name?: string | undefined;
}

export interface ConsumableItemsDTO {
    orderId?: number;
    consumableItems?: StockDTO[] | undefined;
}

export interface CreateItemConsumptionDTO {
    legalEntityId?: string | undefined;
    projectId?: string | undefined;
    projectLegalEntityId?: string | undefined;
    warehouseId?: string | undefined;
    workTaskId?: number;
    items?: ItemDTO[] | undefined;
}

export interface CreateOrderItemDTO {
    itemId?: string | undefined;
    qty?: number;
}

export interface CreateReturnOrderDTO {
    fromWarehouseId?: string | undefined;
    workOrderId?: string | undefined;
    description?: string | undefined;
    workTaskId?: number;
    items?: CreateOrderItemDTO[] | undefined;
}

export interface CreateTimeRegistrationDTO {
    date?: string;
    legalEntityId?: string | undefined;
    projectLegalEntityId?: string | undefined;
    projectId?: string | undefined;
    categoryId?: string | undefined;
    email?: string | undefined;
    description?: string | undefined;
    hours?: number;
    workTaskId?: number | undefined;
    categoryGroupId?: string | undefined;
}

export interface CreateTransferJournalDTO {
    fromWarehouseId?: string | undefined;
    toWarehouseId?: string | undefined;
    fromLocationId?: string | undefined;
    toLocationId?: string | undefined;
    items?: CreateTransferJournalItemDTO[] | undefined;
}

export interface CreateTransferJournalItemDTO {
    itemId?: string | undefined;
    qty?: number;
    batchNumber?: string | undefined;
    serialNumber?: string | undefined;
    cableCut?: boolean | undefined;
}

export interface CreateTransferOrderDTO {
    warehouseId?: string | undefined;
    description?: string | undefined;
    receiptDate?: string;
    workTaskId?: number | undefined;
    taskTypeId?: number | undefined;
    projectId?: string | undefined;
    projectLegalEntityId?: string | undefined;
    items?: CreateTransferOrderItemDTO[] | undefined;
}

export interface CreateTransferOrderItemDTO {
    itemId?: string | undefined;
    qty?: number;
}

export interface DetailedEmployeeInfoDTO {
    vehicle?: VehicleDTO;
    employeeInfos?: EmployeeInfoDTO[] | undefined;
}

export interface DropPointDTO {
    warehouseId?: string | undefined;
    name?: string | undefined;
    streetName?: string | undefined;
    houseNumber?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    latitude?: number;
    longitude?: number;
}

export interface EmployeeInfoDTO {
    employeeId?: string | undefined;
    region?: Region2;
    legalEntityId?: string | undefined;
    categoryLinks?: CategoryLinkDTO[] | undefined;
}

export interface ExcessItemsDTO {
    movedToVehicle?: boolean;
    orderId?: number;
    excessItems?: StockDTO[] | undefined;
}

export interface FavoriteItemGroupDTO {
    groupId?: number;
    name?: string | undefined;
    itemIds?: string[] | undefined;
}

export interface GroupCategoryProjectDTO {
    categories?: CategoryDTO2[] | undefined;
    projects?: ProjectDTO2[] | undefined;
}

export enum ImageReportType {
    BadQuality = "BadQuality",
    WrongItem = "WrongItem",
    NotFound = "NotFound",
}

export interface ItemConsumptionDTO {
    itemOrderId?: number;
    legalEntityId?: string | undefined;
    projectId?: string | undefined;
    employeeName?: string | undefined;
    warehouseName?: string | undefined;
    date?: string;
    items?: ItemDTO[] | undefined;
}

export interface ItemCountingDTO {
    itemCountingLines?: ItemCountingLineDTO[] | undefined;
    created?: string;
}

export interface ItemCountingLineDTO {
    itemId?: string | undefined;
    itemName?: string | undefined;
    quantity?: number;
    checked?: boolean;
}

export interface ItemDTO {
    lineId?: number;
    itemId?: string | undefined;
    itemName?: string | undefined;
    location?: string | undefined;
    qty?: number;
    batchNumber?: string | undefined;
    serialNumber?: string | undefined;
}

export interface ItemImageReportDTO {
    itemId?: string | undefined;
    imageUrl?: string | undefined;
    reportType?: ImageReportType;
}

export interface OrderDTO {
    orderId?: number;
    transferId?: string | undefined;
    description?: string | undefined;
    orderStatus?: OrderStatus;
    created?: string;
    requestedReceiptDate?: string;
    expectedReceiptDate?: string | undefined;
    createdByEmail?: string | undefined;
    fromWarehouseId?: string | undefined;
    toWarehouseId?: string | undefined;
    toWarehouseName?: string | undefined;
    isFulfilled?: boolean;
    items?: OrderItemDTO[] | undefined;
    workTaskId?: number | undefined;
}

export interface OrderItemDTO {
    itemId?: string | undefined;
    name?: string | undefined;
    qty?: number;
    isFulfilled?: boolean;
}

export interface OrderItemDTO2 {
    itemId?: string | undefined;
    totalQty?: number;
}

export enum OrderStatus {
    Pending = "Pending",
    Created = "Created",
    Shipped = "Shipped",
    Delivered = "Delivered",
    Received = "Received",
}

export interface PersonDTO2 {
    name?: string | undefined;
    email?: string | undefined;
}

export interface ProductDTO {
    itemId?: string | undefined;
    name?: string | undefined;
    batchNumber?: string | undefined;
    serialNumber?: string | undefined;
    pictureLinks?: string[] | undefined;
}

export interface ProductDetailDTO {
    itemId?: string | undefined;
    description?: string | undefined;
    name?: string | undefined;
    alternativeItemId?: string | undefined;
    alternativeProductName?: string | undefined;
    searchName?: string | undefined;
    inventoryUnitId?: string | undefined;
    productStateCode?: string | undefined;
    businessArea?: string | undefined;
    legalEntityId?: string | undefined;
    itemGroupId?: string | undefined;
    itemGroupName?: string | undefined;
    pictureLinks?: string[] | undefined;
    favorite?: boolean;
}

export interface ProjectDTO {
    id: string;
    name?: string | undefined;
    legalEntityId: string;
    region: Region2;
    isActive?: boolean;
    projectManager?: PersonDTO2;
}

export interface ProjectDTO2 {
    id: string;
    name?: string | undefined;
    legalEntityId: string;
    projectManager?: PersonDTO2;
}

export enum Region2 {
    North = "North",
    South = "South",
    OneERP = "OneERP",
}

export interface StockDTO {
    product?: ProductDTO;
    maxOnHand?: number | undefined;
    minOnHand?: number | undefined;
    available?: number;
    batchNumber?: string | undefined;
    serialNumber?: string | undefined;
    warehouseId?: string | undefined;
    locationId?: string | undefined;
}

export interface TimeRegistrationDTO {
    id?: number;
    date?: string;
    employee?: string | undefined;
    category?: CategoryDTO;
    description?: string | undefined;
    hours?: number;
    isSentToErp?: boolean;
    isDeleted?: boolean;
    approvedByUser?: boolean;
    project?: ProjectDTO;
    workTaskId?: number | undefined;
    categoryGroupId?: string | undefined;
    relatedToLineId?: number;
}

export interface TransferItemDTO {
    itemId?: string | undefined;
    name?: string | undefined;
    qty?: number;
    cableCut?: boolean | undefined;
}

export interface TransferOrderDTO {
    transferId?: string | undefined;
    transferStatus?: string | undefined;
    consignorId?: string | undefined;
    moveToIssueLocationStatus?: string | undefined;
    receiveDate?: string;
    items?: TransferItemDTO[] | undefined;
}

export interface UpdateStockDTO {
    product?: ProductDTO;
    quantity?: number;
}

export interface UpdateTimeRegistrationDTO {
    date?: string;
    legalEntityId?: string | undefined;
    projectLegalEntityId?: string | undefined;
    projectId?: string | undefined;
    categoryId?: string | undefined;
    email?: string | undefined;
    description?: string | undefined;
    hours?: number;
}

export interface UpdateWorkInvoiceDTO {
    contactPersonName?: string | undefined;
    contactPersonPhoneNumber?: string | undefined;
    contactPersonAddress?: string | undefined;
    cvrNo?: string | undefined;
    vehicleRegNo?: string | undefined;
    policeCaseNo?: string | undefined;
    note?: string | undefined;
}

export interface VehicleDTO {
    vehicleName?: string | undefined;
    vehicleId?: string | undefined;
    legalEntityId?: string | undefined;
    defaultIssueLocationId?: string | undefined;
    defaultReceiptLocationId?: string | undefined;
}

export interface WarehouseDTO {
    legalEntityId?: string | undefined;
    warehouseId?: string | undefined;
    name?: string | undefined;
}

export interface WarehouseExtendedDTO {
    legalEntityId?: string | undefined;
    warehouseId?: string | undefined;
    name?: string | undefined;
    defaultIssueLocationId?: string | undefined;
    defaultReceiptLocationId?: string | undefined;
}

export interface WorkInvoiceDTO {
    workInvoiceId?: number;
    workTaskId?: number;
    contactPersonName?: string | undefined;
    contactPersonPhoneNumber?: string | undefined;
    contactPersonAddress?: string | undefined;
    note?: string | undefined;
    cvrNo?: string | undefined;
    vehicleRegNo?: string | undefined;
    policeCaseNo?: string | undefined;
    projectCategory?: WorkInvoiceProjectCategory;
    unknownDebtor?: boolean;
    legalEntityId?: string | undefined;
    projectId?: string | undefined;
    updatedBy?: string | undefined;
    created?: string;
    lastUpdated?: string;
}

export enum WorkInvoiceProjectCategory {
    LowVoltage = "LowVoltage",
    MediumVoltage = "MediumVoltage",
    HighVoltage = "HighVoltage",
    Meter = "Meter",
}

export interface WorkInvoiceResponseDTO {
    workInvoiceDTO?: WorkInvoiceDTO;
}

export interface WorkplanOrderDTO {
    order?: OrderDTO;
    dropPoint?: DropPointDTO;
}

export interface AssetResultDTO {
    assetId?: string | undefined;
    assetType?: AssetType2;
    primaryVoltage?: number | undefined;
    location?: LocationDTO;
    region?: Region;
    gisRegion?: GisRegion;
    accessConditions?: AccessConditionsDTO;
    assetGisMigrationId?: string | undefined;
    assetDynamicsFunctionalLocationId?: string | undefined;
}

export interface CreateInternalTaskTimeRegistrationDTO2 {
    date?: string | undefined;
    description?: string | undefined;
    hours?: number | undefined;
    id?: number | undefined;
    projectNumber?: string | undefined;
}

export interface DetailedTimeRegistrationDTO {
    id?: number;
    date?: string;
    employee?: string | undefined;
    category?: CategoryDTO;
    description?: string | undefined;
    hours?: number;
    isSentToErp?: boolean;
    isDeleted?: boolean;
    approvedByUser?: boolean;
    project?: ProjectDTO;
    workTaskId?: number | undefined;
    categoryGroupId?: string | undefined;
    relatedToLineId?: number;
    taskType?: string | undefined;
    address?: LocationDTO;
    baseWorkTaskType?: BaseWorkTaskTypeEnum;
}

export interface EmployeeInfoResultDTO {
    employeeInfo?: DetailedEmployeeInfoDTO;
    department?: Department3;
}

export interface MessageDTO {
    messageType?: MessageType;
    baseWorkTaskId?: number | undefined;
    authorName?: string | undefined;
    authorUsername?: string | undefined;
    text?: string | undefined;
    status?: WorkTaskStatus;
    department?: Department;
    responsible?: string | undefined;
    assignedTechnician?: string | undefined;
    bookingState?: BookingState;
    oldBookingState?: BookingState;
    timeStamp?: string | undefined;
    isFlagged?: boolean;
    commentId?: number | undefined;
    hasUserRemarks?: boolean;
}

export enum MessageType {
    Comment = "Comment",
    StatusTransaction = "StatusTransaction",
    DepartmentTransaction = "DepartmentTransaction",
    ResponsibleTransaction = "ResponsibleTransaction",
    AssignedTechnicianTransaction = "AssignedTechnicianTransaction",
    BookingStatusTransaction = "BookingStatusTransaction",
}

export interface MeterReplacementInfoDTO {
    canToggleMeterReplace?: boolean;
    isReplacingMeter?: boolean;
}

export interface MeterTaskInfoDTO {
    workOrderInfo?: WorkOrderInfoDto;
    meterReplacementInfo?: MeterReplacementInfoDTO;
}

export interface ProfileDTO {
    firstLoad?: boolean;
    role?: ProfileDTO2Role;
    department?: DepartmentDTO;
    name?: string | undefined;
    region?: ProfileDTO2Region;
    vehicle?: VehicleDTO;
    phone?: string | undefined;
    defaultDropPoint?: DropPointDTO;
    favoriteDropPoint?: DropPointDTO;
    isAutomaticNotificationsEnabled?: boolean;
}

export interface ProfileDTO2 {
    firstLoad?: boolean;
    role?: ProfileDTO2Role;
    department?: DepartmentDTO;
    name?: string | undefined;
    region?: ProfileDTO2Region;
    defaultWarehouseId?: string | undefined;
    vehicle?: VehicleDTO;
    phone?: string | undefined;
    defaultDropPoint?: DropPointDTO;
    favoriteDropPoint?: DropPointDTO;
    isAutomaticNotificationsEnabled?: boolean;
}

export enum Department3 {
    Planning = "Planning",
    Meterdata = "Meterdata",
    MeterWorkshop = "MeterWorkshop",
    CustomerConnection = "CustomerConnection",
    TechnicalSupport = "TechnicalSupport",
    Documentation = "Documentation",
    ControlRoom = "ControlRoom",
    Deleted_NetworkStrategy = "Deleted_NetworkStrategy",
    AdministrativeSupport = "AdministrativeSupport",
    SupportCenter = "SupportCenter",
    NetworkDesign = "NetworkDesign",
    ProjectEstablishment = "ProjectEstablishment",
    ProjectExecution = "ProjectExecution",
    Scada = "Scada",
    Automation = "Automation",
    Maintenance = "Maintenance",
    OnsiteSupport = "OnsiteSupport",
}

export interface Anonymous {
    status?: string;
    errors?: string;

    [key: string]: any;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}